/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/brace-style */
/* eslint-disable no-await-in-loop */
/* eslint-disable class-methods-use-this */
import {
  AbiCoder,
  formatEther,
  formatUnits,
  getAddress,
  Interface,
  isAddress,
  isBytesLike,
  toBeHex,
  ZeroAddress
} from 'ethers'

import { debugTraceCall, getStateOverride } from '@/libs/tracer/debugTraceCall'

import AmbireAccount from '../../../contracts/compiled/AmbireAccount.json'
import ERC20 from '../../../contracts/compiled/IERC20.json'
import EmittableError from '../../classes/EmittableError'
import ExternalSignerError from '../../classes/ExternalSignerError'
import {
  IRecurringTimeout,
  RecurringTimeout
} from '../../classes/recurringTimeout/recurringTimeout'
import { EIP7702Auth } from '../../consts/7702'
import { FEE_COLLECTOR } from '../../consts/addresses'
import {
  EIP_7702_AMBIRE_ACCOUNT,
  EIP_7702_AMBIRE_LEGACY,
  EIP_7702_GRID_PLUS,
  EIP_7702_KATANA,
  SINGLETON
} from '../../consts/deploy'
import gasTankFeeTokens from '../../consts/gasTankFeeTokens'
import { ESTIMATE_UPDATE_INTERVAL, GAS_PRICE_UPDATE_INTERVAL } from '../../consts/intervals'
import {
  ERRORS,
  RETRY_TO_INIT_ACCOUNT_OP_MSG,
  WARNINGS
} from '../../consts/signAccountOp/errorHandling'
import {
  GAS_TANK_TRANSFER_GAS_USED,
  RELAYER_GAS_LIMIT_REMEASURE_THRESHOLD,
  RELAYER_GAS_LIMIT_REMEASURE_TIMEOUT_MS,
  RELAYER_REMEASURED_GAS_BUFFER_BPS,
  SA_ERC20_TRANSFER_GAS_USED,
  SA_NATIVE_TRANSFER_GAS_USED
} from '../../consts/signAccountOp/gas'
import { Account, AccountOnchainState, IAccountsController } from '../../interfaces/account'
import { IActivityController } from '../../interfaces/activity'
import { Price } from '../../interfaces/assets'
import { DAPP_VERIFICATION_BANNER_IDS, IDappsController } from '../../interfaces/dapp'
import { ErrorRef, IEventEmitterRegistryController } from '../../interfaces/eventEmitter'
import { Hex } from '../../interfaces/hex'
import {
  ExternalKey,
  ExternalSignerControllers,
  IKeystoreController,
  InternalKey,
  Key,
  KeystoreSignerInterface
} from '../../interfaces/keystore'
import { INetworksController, Network } from '../../interfaces/network'
import { IPhishingController } from '../../interfaces/phishing'
import { IPortfolioController } from '../../interfaces/portfolio'
import { RPCProvider } from '../../interfaces/provider'
import {
  HardwareWalletSigningRequest,
  ISignAccountOpController,
  SignAccountOpBanner,
  SignAccountOpError,
  TraceCallDiscoveryStatus,
  Warning
} from '../../interfaces/signAccountOp'
import { IStorageController } from '../../interfaces/storage'
import { UserRequest } from '../../interfaces/userRequest'
import { getContractImplementation } from '../../libs/7702/7702'
import {
  canBecomeSmarter,
  isAmbireV1LinkedAccount,
  isSmartAccount
} from '../../libs/account/account'
import { BaseAccount } from '../../libs/account/BaseAccount'
import { canFeeOptionCoverAmount, isTransferredTokenFeeOption } from '../../libs/account/feeOptions'
import { getBaseAccount } from '../../libs/account/getBaseAccount'
import { Safe } from '../../libs/account/Safe'
import { AccountOp, GasFeePayment, getSignableCalls } from '../../libs/accountOp/accountOp'
import {
  AccountOpIdentifiedBy,
  isIdentifiedByRelayer,
  SubmittedAccountOp
} from '../../libs/accountOp/submittedAccountOp'
import { AccountOpStatus } from '../../libs/accountOp/types'
import { getScamDetectedText } from '../../libs/banners/banners'
import {
  BROADCAST_OPTIONS,
  broadcastTransaction,
  buildRawTransaction
} from '../../libs/broadcast/broadcast'
import { PaymasterErrorReponse, PaymasterSuccessReponse, Sponsor } from '../../libs/erc7677/types'
import { getHumanReadableBroadcastError } from '../../libs/errorHumanizer'
import { insufficientPaymasterFunds } from '../../libs/errorHumanizer/errors'
import { bundlerEstimate, fetchBundlerGasPrice } from '../../libs/estimate/estimateBundler'
import {
  Erc4337GasLimits,
  FeePaymentOption,
  FullEstimationSummary
} from '../../libs/estimate/interfaces'
import { calculateFeeAmount } from '../../libs/fees/fees'
import { applyRelayerFeeGasBuffer, getRelayerSimulatedGasLimit } from '../../libs/gasPrice/gasPrice'
import {
  areFeeSelectionPreferencesEqual,
  FeeSelectionPreference,
  FeeSelectionPreferences,
  findFeeOptionByPreference,
  getFeeSelectionPreferenceKey
} from '../../libs/feeSelectionPreference/feeSelectionPreference'
import { humanizeAccountOp } from '../../libs/humanizer'
import { HumanizerWarning, IrCall } from '../../libs/humanizer/interfaces'
import { hasRelayerSupport, relayerAdditionalNetworks } from '../../libs/networks/networks'
import { AbstractPaymaster } from '../../libs/paymaster/abstractPaymaster'
import {
  getSponsorshipAuthorizationTypedData,
  SPONSORSHIP_SESSION_TTL_SECONDS,
  SponsorshipAuthorization,
  SponsorshipAuthorizer
} from '../../libs/paymaster/sponsorshipAuthorization'
import { GetOptions, TokenResult } from '../../libs/portfolio'
import {
  confirm,
  getAlreadySignedOwners,
  getImportedSignersThatHaveNotSigned,
  getNonce,
  getSafeTxn,
  getSafeTxnHash,
  getSigs,
  propose,
  sortSigs
} from '../../libs/safe/safe'
import {
  get7702AuthorizationSigningRequest,
  getEIP712SigningRequest,
  getExecuteSigningRequest,
  getRawTransactionSigningRequest,
  getSigningRequestDisplayData
} from '../../libs/signingRequest/signingRequest'
import {
  adjustEntryPointAuthorization,
  get7702Sig,
  getEIP712Signature,
  getEntryPointAuthorization,
  get7702UserOpTypedData,
  getExecuteSignature,
  getTypedData,
  wrapStandard,
  wrapUnprotected
} from '../../libs/signMessage/signMessage'
import { isPermit2Interaction } from '../../libs/simulation/detectPermit2Interaction'
import { getGasUsed } from '../../libs/singleton/singleton'
import { createAccessListCall, getShouldUseAccessListCall } from '../../libs/tracer/accessListCall'
import { UserOperation } from '../../libs/userOperation/types'
import {
  getActivatorCall,
  getPackedUserOp,
  getUserOperation,
  getUserOpHash
} from '../../libs/userOperation/userOperation'
import { BundlerSwitcher } from '../../services/bundlers/bundlerSwitcher'
import { GasSpeeds } from '../../services/bundlers/types'
import { failedPaymasters } from '../../services/paymaster/FailedPaymasters'
import { sponsorshipSessions } from '../../services/paymaster/SponsorshipSessions'
import { rebroadcastToBackupRpcs } from '../../services/provider/FailoverJsonRpcProvider'
import { ZERO_ADDRESS } from '../../services/socket/constants'
import shortenAddress from '../../utils/shortenAddress'
import { generateUuid } from '../../utils/uuid'
import { EstimationController } from '../estimation/estimation'
import { EstimationStatus } from '../estimation/types'
import EventEmitter from '../eventEmitter/eventEmitter'
import { GasPriceController } from '../gasPrice/gasPrice'
import {
  applyGasPriceFloor,
  getFeeSpeedIdentifier,
  getFeeTokenPriceUnavailableWarning,
  getSignificantBalanceDecreaseWarning,
  getTokenUsdAmount,
  getUnknownTokenWarning,
  isFeeBelowBroadcastCost,
  isUnderpriced,
  SignAccountOpType
} from './helper'

export enum SigningStatus {
  EstimationError = 'estimation-error',
  UnableToSign = 'unable-to-sign',
  ReadyToSign = 'ready-to-sign',
  /**
   * Used to prevent state updates while the user is resolving warnings, connecting a hardware wallet, etc.
   * Signing is allowed in this state, but the state of the controller should not change.
   */
  UpdatesPaused = 'updates-paused',
  InProgress = 'in-progress',
  WaitingForPaymaster = 'waiting-for-paymaster-response',
  Done = 'done',
  Queued = 'queued'
}

export type Status = {
  // @TODO: get rid of the object and just use the type
  type: SigningStatus
}

export enum FeeSpeed {
  Slow = 'slow',
  Medium = 'medium',
  Fast = 'fast',
  Ape = 'ape'
}

export type SpeedCalc = {
  type: FeeSpeed
  amount: bigint
  simulatedGasLimit: bigint
  amountFormatted: string
  amountUsd: string
  gasPrice: bigint
  disabled: boolean
  maxPriorityFeePerGas?: bigint
}

// How long a multi-txn broadcast waits for one txn to land before moving on to the
// next one. Applied twice at most (once before and once after re-sending the txn to
// the network's other endpoints), so the total ceiling matches the 90s the
// WalletConnect path has always used.
const BROADCAST_INCLUSION_TIMEOUT = 45000

// declare the statuses we don't want state updates on
export const noStateUpdateStatuses = [
  SigningStatus.InProgress,
  SigningStatus.Done,
  SigningStatus.UpdatesPaused,
  SigningStatus.WaitingForPaymaster
]

export type SignAccountOpUpdateProps = {
  gasPrices?: GasSpeeds
  customGasPrices?: GasSpeeds
  customGasLimit?: bigint
  feeToken?: TokenResult
  paidBy?: string
  paidByKeyType?: Key['type']
  speed?: FeeSpeed
  signingKeyAddr?: Key['addr']
  signingKeyType?: InternalKey['type'] | ExternalKey['type']
  signedTransactionsCount?: number | null
  hasNewEstimation?: boolean
  accountOpData?: Partial<AccountOp>
}

export type OnboardingSuccessProps = {
  submittedAccountOp: SubmittedAccountOp
  accountOp: AccountOp
  type: SignAccountOpType
  fromRequestId: string | number
}

export type OnBroadcastSuccess = (props: OnboardingSuccessProps) => Promise<void>

export type OnBroadcastFailed = (accountOp: AccountOp) => void

export class SignAccountOpController extends EventEmitter implements ISignAccountOpController {
  #type: SignAccountOpType

  #callRelayer: Function

  #accounts: IAccountsController

  #keystore: IKeystoreController

  #portfolio: IPortfolioController

  #externalSignerControllers: ExternalSignerControllers

  account: Account

  baseAccount: BaseAccount

  #network: Network

  #phishing: IPhishingController

  #storage: IStorageController

  /** null until the stored preferences are read from storage */
  #feeSelectionPreferences: FeeSelectionPreferences | null = null

  #feeSelectionPreferencesLoadPromise: Promise<void>

  /**
   * The stored "Pay fee with" preference is applied at most once per
   * controller instance, and never after the user has picked an option.
   */
  #hasResolvedFeeOptionPreference: boolean = false

  #hasUserSelectedFeeOption: boolean = false

  // this is not used in the controller directly but it's being read outside
  fromRequestId: UserRequest['id']

  hasSafeApiFailed: boolean = false

  /**
   * Never modify this directly, use #updateAccountOp instead.
   * Otherwise the accountOp will be out of sync with the one stored
   * in requests/actions.
   */
  #accountOp: AccountOp

  gasPrices?: GasSpeeds

  hasCustomGasPrices: boolean = false

  /**
   * ZKX: the replacement-fee FLOOR of a speed-up, i.e. the pending txn's own
   * prices already bumped by the caller. Every speed we offer must stay above
   * it (a replacement below the original is rejected outright), but it is a
   * floor, NOT the price: the live network prices still apply on top, so the
   * speeds keep meaning something and a txn stuck because the ORIGINAL price
   * was too low for the chain can actually be unstuck.
   */
  #speedUpGasPriceFloor: { maxFeePerGas: bigint; maxPriorityFeePerGas: bigint } | null = null

  customGasLimit?: bigint

  feeSpeeds: {
    [identifier: string]: SpeedCalc[]
  } = {}

  #paidBy: string | null = null

  /**
   * The selected fee token the user is going to broadcast with.
   * This probably exists in selectedOption as well and it could
   * be refactored away someday
   */
  feeTokenResult: TokenResult | null = null

  selectedFeeSpeed: FeeSpeed | null = FeeSpeed.Fast

  /**
   * The selected payment option for txn broadcasting.
   * Depending on the account type, it could be various tokens,
   * gas tank, or payment by another EOA
   */
  selectedOption: FeePaymentOption | undefined = undefined

  status: Status | null = null

  broadcastStatus: 'INITIAL' | 'LOADING' | 'SUCCESS' | 'ERROR' = 'INITIAL'

  signedAccountOp: AccountOp | null

  replacementFeeLow: boolean

  warnings: Warning[] = []

  // indicates whether the transaction gas is sponsored or not
  isSponsored: boolean = false

  // the sponsor data to be displayed, if any
  sponsor: Sponsor | undefined = undefined

  bundlerSwitcher: BundlerSwitcher

  signedTransactionsCount: number | null = null

  hardwareWalletSigningRequest: HardwareWalletSigningRequest | null = null

  // We track the status of token discovery logic (main.traceCall)
  // to ensure the "SignificantBalanceDecrease" banner is displayed correctly.
  // The latest/pending portfolio balance is essential for calculating balance differences.
  // However, during a SWAP, the user may receive a new token that isn't yet included (discovered) in the portfolio.
  // If the discovery process is in-process, and we only rely on portfolio balance change,
  // the banner may be incorrectly triggered due to the perceived balance drop.
  // Once discovery completes and updates the portfolio, the banner will be hidden.
  traceCallDiscoveryStatus: TraceCallDiscoveryStatus = TraceCallDiscoveryStatus.NotStarted

  // the calculated gas used for the transaction estimation
  // it now depends on a variety of options and hence the need to move it
  // as its own property
  gasUsed: bigint = 0n

  provider: RPCProvider

  estimation: EstimationController

  humanization: IrCall[] = []

  humanizationId: number | null = null

  gasPrice: GasPriceController

  shouldSignAuth: {
    type: 'V2Deploy' | '7702'
    text: string
  } | null = null

  /**
   * Should this signAccountOp instance simulate the accountOp it's
   * preparing as well as estimate. Simulaton is required in the
   * original signAccountOp but should be avoided in swap&bridge
   */
  #shouldSimulate: boolean

  #reestimateCounter: number = 0

  /**
   * Controls internal continuous updates - gasPrice and estimation.
   * When true, both intervals should be stopped and even if they
   * are not, they shouldn't make any calls/updates (fallback measure).
   */
  #stopRefetching: boolean = false

  #activity: IActivityController

  #dapps: IDappsController

  #onUpdateAfterTraceCallSuccess?: () => Promise<void>

  #onBroadcastSuccess: OnBroadcastSuccess

  #onBroadcastFailed?: OnBroadcastFailed

  #updateBlacklistedStatusPromise: Promise<void> | undefined

  signPromise: Promise<void> | undefined

  broadcastPromise: Promise<void> | undefined

  signAndBroadcastPromise: Promise<void> | undefined

  /**
   * True while the user has clicked Sign on this AccountOp but the wallet is
   * still waiting for an earlier sign+broadcast on the same (account, chain)
   * to finish before it can hand off the sign request to the signer. Used by
   * the UI to show a loading state on the Sign button so the user knows their
   * click registered (and to prevent duplicate clicks).
   */
  isSignQueuedAfterPreviousBroadcast: boolean = false

  #traceCallTimeoutId: ReturnType<typeof setTimeout> | null = null

  #gasPriceInterval: IRecurringTimeout

  #simulateAndEstimateOrSimulateInterval: IRecurringTimeout

  #onDappsUpdateUnsubscribe?: () => void

  /**
   * The gas price / estimation intervals live in the background and keep running
   * long after the user closes the popup, because nothing in the popup-overlay
   * signing path (`shouldSignInsidePopup`) ever calls `pause()` on us. Rather than
   * pausing the whole controller — which unregisters it from the registry and has
   * no counterpart resume() for the Swap / Transfer / Shield flows — we simply skip
   * the recurring gas price fetch while no view is watching. The interval keeps its
   * schedule, so the first tick after a view reopens fetches as usual.
   */
  #getHasOpenView: () => boolean = () => true

  constructor({
    eventEmitterRegistry,
    type,
    callRelayer,
    accounts,
    networks,
    keystore,
    portfolio,
    externalSignerControllers,
    account,
    network,
    activity,
    dapps,
    provider,
    phishing,
    storage,
    fromRequestId,
    accountOp,
    shouldSimulate,
    getHasOpenView,
    onUpdateAfterTraceCallSuccess,
    onBroadcastSuccess,
    onBroadcastFailed
  }: {
    eventEmitterRegistry?: IEventEmitterRegistryController
    type?: SignAccountOpType
    callRelayer: Function
    accounts: IAccountsController
    networks: INetworksController
    keystore: IKeystoreController
    portfolio: IPortfolioController
    externalSignerControllers: ExternalSignerControllers
    account: Account
    network: Network
    activity: IActivityController
    dapps: IDappsController
    provider: RPCProvider
    phishing: IPhishingController
    storage: IStorageController
    fromRequestId: UserRequest['id']
    accountOp: AccountOp
    shouldSimulate: boolean
    /**
     * Whether any wallet view (popup / tab / request window) is currently open.
     * Defaults to always-true for platforms that don't track views.
     */
    getHasOpenView?: () => boolean
    onUpdateAfterTraceCallSuccess?: () => Promise<void>
    onBroadcastSuccess: OnBroadcastSuccess
    onBroadcastFailed?: OnBroadcastFailed
  }) {
    super(eventEmitterRegistry, false)
    this.#type = type || 'default'
    this.#callRelayer = callRelayer
    this.#accounts = accounts
    this.#keystore = keystore
    this.#portfolio = portfolio
    this.#externalSignerControllers = externalSignerControllers
    this.account = account
    const accountState = accounts.accountStates[account.addr]![network.chainId.toString()]! // ! is safe as otherwise, nothing will work
    this.baseAccount = getBaseAccount(account, accountState, network)
    this.#network = network
    this.#activity = activity
    this.#dapps = dapps
    this.#phishing = phishing
    this.#storage = storage
    this.#feeSelectionPreferencesLoadPromise = this.#loadFeeSelectionPreferences()
    this.fromRequestId = fromRequestId
    this.#accountOp = structuredClone(accountOp)
    this.#setSpeedUpGasPrices()

    if (this.#accountOp.signature && this.#accountOp.txnId) {
      this.#accountOp.signed = getAlreadySignedOwners(
        this.#accountOp.signature,
        this.#accountOp.txnId,
        this.#accountOp.safeTx
      )
      const notSigned = getImportedSignersThatHaveNotSigned(
        this.#accountOp.signed,
        accountState.importedAccountKeys.map((k) => k.addr)
      )

      // make the status queued if there are no additional owners left to sign
      if (this.#accountOp.signed.length < accountState.threshold && !notSigned.length)
        this.status = { type: SigningStatus.Queued }
    }

    this.signedAccountOp = null
    this.replacementFeeLow = false
    this.bundlerSwitcher = new BundlerSwitcher(
      network,
      () => {
        return this.status ? noStateUpdateStatuses.indexOf(this.status.type) !== -1 : false
      },
      { canDelegate: this.baseAccount.shouldSignAuthorization(BROADCAST_OPTIONS.byBundler) }
    )
    this.provider = provider
    this.estimation = new EstimationController(
      keystore,
      accounts,
      networks,
      provider,
      portfolio,
      this.bundlerSwitcher,
      this.#activity
    )
    this.#onUpdateAfterTraceCallSuccess = onUpdateAfterTraceCallSuccess
    this.gasPrice = new GasPriceController(network, provider, this.baseAccount, () => ({
      estimation: this.estimation,
      readyToSign: this.readyToSign,
      stopRefetching: this.#stopRefetching
    }))
    this.#shouldSimulate = shouldSimulate
    if (getHasOpenView) this.#getHasOpenView = getHasOpenView

    this.#onBroadcastSuccess = onBroadcastSuccess
    if (onBroadcastFailed) this.#onBroadcastFailed = onBroadcastFailed

    // Intervals
    this.#gasPriceInterval = new RecurringTimeout(async () => {
      // Null when the controller is destroyed
      if (!this.gasPrice || this.#stopRefetching) {
        this.#gasPriceInterval.stop()
        return
      }

      // Nobody is looking: don't hammer the chain's RPC (and don't raise fee
      // errors) while every wallet view is closed. See #getHasOpenView.
      if (!this.#getHasOpenView()) return

      await this.gasPrice.fetch('major')
    }, GAS_PRICE_UPDATE_INTERVAL)

    this.#simulateAndEstimateOrSimulateInterval = new RecurringTimeout(async () => {
      if (!this.estimation || this.#stopRefetching) {
        this.#simulateAndEstimateOrSimulateInterval.stop()
        return
      }

      await this.#simulateAndEstimateOrEstimate()
    }, ESTIMATE_UPDATE_INTERVAL)
    // Intervals end

    this.#load()
  }

  get safetyChecksLoading() {
    return !!this.#updateBlacklistedStatusPromise
  }

  get accountOp(): Readonly<AccountOp> {
    return this.#accountOp
  }

  get isSpeedUpTransaction(): boolean {
    return !!this.#accountOp.meta?.speedUp?.enabled
  }

  #updateAccountOp(accountOp: Partial<AccountOp>) {
    if (!Object.keys(accountOp).length) return

    const hasUpdatedCalls = !!accountOp.calls

    this.#accountOp = {
      ...this.#accountOp,
      ...accountOp,
      id: hasUpdatedCalls ? generateUuid() : this.#accountOp.id
    }
  }

  #setHardwareWalletSigningRequest(request: HardwareWalletSigningRequest | null) {
    let serializedRequestData: unknown = null

    try {
      if (request) serializedRequestData = getSigningRequestDisplayData(request)
    } catch {
      serializedRequestData = null
    }

    this.hardwareWalletSigningRequest =
      request && serializedRequestData !== null
        ? {
            ...request,
            data: serializedRequestData
          }
        : null
    this.emitUpdate()
  }

  async #withHardwareWalletSigningRequest<T>(
    request: HardwareWalletSigningRequest | null,
    sign: () => Promise<T>
  ) {
    if (!request) return sign()

    this.#setHardwareWalletSigningRequest(request)

    try {
      return await sign()
    } finally {
      this.#setHardwareWalletSigningRequest(null)
    }
  }

  /**
   * Wait for one txn of a multi-txn broadcast to make it on chain before the next
   * one is built.
   *
   * Capped and best-effort by design: on timeout the caller carries on, because the
   * next call's gas estimation falls back to the batch-wide simulated limit and the
   * sequential nonces keep the on-chain execution order intact either way.
   *
   * If the txn hasn't been mined within the first window we re-send it to the
   * network's other endpoints. A signed txn that reaches only one node can sit in
   * that node's mempool without propagating — observed on PulseChain, where it took
   * a manual re-send to another RPC to get the txn mined.
   */
  async #waitForInclusion(hash: string, rawTxn?: string): Promise<void> {
    const isMined = await this.provider
      .waitForTransaction(hash, 1, BROADCAST_INCLUSION_TIMEOUT)
      .catch(() => null)
    if (isMined) return

    if (rawTxn) await rebroadcastToBackupRpcs(this.provider, rawTxn)

    await this.provider.waitForTransaction(hash, 1, BROADCAST_INCLUSION_TIMEOUT).catch(() => null)
  }

  #syncSpeedUpFeeSelectionFromEstimation() {
    if (
      !this.isSpeedUpTransaction ||
      this.estimation.status !== EstimationStatus.Success ||
      !this.accountOp.gasFeePayment
    ) {
      return
    }

    const selectedOption = this.estimation.availableFeeOptions.find(
      (option) =>
        option.paidBy === this.accountOp.gasFeePayment?.paidBy &&
        option.token.address === this.accountOp.gasFeePayment?.inToken &&
        (!this.accountOp.gasFeePayment?.feeTokenChainId ||
          option.token.chainId === this.accountOp.gasFeePayment?.feeTokenChainId) &&
        option.token.flags.onGasTank === this.accountOp.gasFeePayment?.isGasTank
    )

    if (!selectedOption) return

    this.#paidBy = selectedOption.paidBy
    this.feeTokenResult = selectedOption.token
    this.selectedOption = selectedOption
  }

  #setSpeedUpGasPrices() {
    const gasFeePayment = this.accountOp.gasFeePayment
    if (!this.isSpeedUpTransaction || !gasFeePayment) return

    this.#speedUpGasPriceFloor = {
      maxFeePerGas: gasFeePayment.gasPrice,
      // A legacy chain must stay legacy: forcing a tip back in would broadcast
      // the replacement as type-2 with the (possibly nonsense) original tip.
      maxPriorityFeePerGas: this.#network.feeOptions.is1559
        ? gasFeePayment.maxPriorityFeePerGas || 0n
        : 0n
    }

    // Seed the four speeds with the floor so the UI has prices to render before
    // the first live gas-price fetch lands. `#applySpeedUpGasPriceFloor` takes
    // over from there.
    const maxFeePerGas = toBeHex(this.#speedUpGasPriceFloor.maxFeePerGas) as Hex
    const maxPriorityFeePerGas = toBeHex(this.#speedUpGasPriceFloor.maxPriorityFeePerGas) as Hex

    this.gasPrices = {
      slow: { maxFeePerGas, maxPriorityFeePerGas },
      medium: { maxFeePerGas, maxPriorityFeePerGas },
      fast: { maxFeePerGas, maxPriorityFeePerGas },
      ape: { maxFeePerGas, maxPriorityFeePerGas }
    }
    this.#applySpeedUpGasPriceFloor()
  }

  /**
   * ZKX: raise the live gas prices to the speed-up floor, so the replacement
   * always outbids the pending txn while the fee speeds stay meaningful.
   * No-op when this is not a speed-up. See `applyGasPriceFloor`.
   */
  #applySpeedUpGasPriceFloor() {
    if (!this.#speedUpGasPriceFloor || !this.gasPrices) return

    this.gasPrices = applyGasPriceFloor(this.gasPrices, this.#speedUpGasPriceFloor)
  }

  async #getDefaultSigner() {
    // call this method during signing only

    if (!this.accountOp.signingKeyAddr || !this.accountOp.signingKeyType)
      throw new Error('signing not set')

    const signer = await this.#keystore.getSigner(
      this.accountOp.signingKeyAddr,
      this.accountOp.signingKeyType
    )

    if (signer.init) signer.init(this.#externalSignerControllers[this.accountOp.signingKeyType])
    return signer
  }

  #validateAccountOp(): SignAccountOpError | null {
    const invalidAccountOpError =
      'The transaction is missing essential data. Please contact support.'
    if (!this.accountOp.accountAddr || !isAddress(this.accountOp.accountAddr)) {
      return { title: invalidAccountOpError, code: 'INVALID_ACCOUNT_ADDRESS' }
    }
    if (!this.accountOp.chainId || typeof this.accountOp.chainId !== 'bigint') {
      return { title: invalidAccountOpError, code: 'INVALID_CHAIN_ID' }
    }
    if (!this.accountOp.calls || !this.accountOp.calls.length) {
      return { title: invalidAccountOpError, code: 'NO_CALLS' }
    }

    if (
      // todo<safe>: a way to alarm the user of this
      !this.account.safeCreation &&
      this.accountOp.calls.some(
        (c) =>
          isAddress(c.to) &&
          getAddress(c.to) === getAddress(this.accountOp.accountAddr) &&
          c.data !== '0x'
      )
    )
      return {
        title: 'A malicious transaction found in this batch.',
        code: 'CALL_TO_SELF'
      }

    const warnings: HumanizerWarning[] = this.humanization
      .map((h) => h.warnings)
      .filter((w): w is HumanizerWarning[] => !!w)
      .flat()

    if (warnings.some((w) => w.blocking))
      return {
        title: 'A malicious transaction found in this batch.',
        code: warnings.map((w) => w.code).join(', ')
      }

    let callError: SignAccountOpError | null = null

    for (let index = 0; index < this.accountOp.calls.length; index++) {
      const call = this.accountOp.calls[index]!

      if (!!call.data && !isBytesLike(call.data)) {
        callError = {
          title: 'Invalid bytes-like string in call data.',
          text: 'Please remove all invalid calls if you want to proceed.'
        }
        call.validationError = 'Invalid bytes-like string in call data'

        // Stop after the first invalid call
        break
      } else if (call.to && !isAddress(call.to)) {
        callError = {
          title: 'Invalid to address in call.',
          text: 'Please remove all invalid calls if you want to proceed.'
        }
        call.validationError = 'Invalid to address in call.'

        // Stop after the first invalid call
        break
      }
    }

    return callError
  }

  #load() {
    this.#setDefaults()
    this.humanize()
    this.learnTokens()

    this.estimation.onUpdate(() => {
      this.update({ hasNewEstimation: true })
    })

    this.gasPrice.onUpdate(() => {
      // if gas prices are not set OR there's no bundler estimation,
      // use the gas prices from the controller.
      // otherwise, we're good as gas price also come from the bundlerEstimation
      if (!this.gasPrices || !this.estimation.estimation?.bundlerEstimation) {
        this.update({ gasPrices: this.gasPrice.gasPrices })
      }
    })

    this.gasPrice.onError((error: ErrorRef) => {
      this.emitError(error)
    })

    this.#onDappsUpdateUnsubscribe = this.#dapps.onUpdate((forceEmit) => {
      this.propagateUpdate(forceEmit)
    }, 'sign-account-op-dapps-verification')

    this.#simulateAndEstimateOrSimulateInterval.start({
      runImmediately: true,
      timeout: ESTIMATE_UPDATE_INTERVAL
    })
    this.#gasPriceInterval.start({ runImmediately: true, timeout: GAS_PRICE_UPDATE_INTERVAL })
  }

  humanize() {
    this.humanization = humanizeAccountOp(this.accountOp)
    const currentHumanizationId = Date.now()
    this.humanizationId = currentHumanizationId
    if (this.humanization.length) {
      this.#updateBlacklistedStatusPromise = this.#phishing
        .updateAddressesBlacklistedStatus(
          this.humanization
            .flatMap((call) =>
              (call.fullVisualization ?? [])
                .filter((v) => v.type === 'token' || v.type === 'address')
                .map((v) => v.address)
            )
            .filter((addr): addr is string => Boolean(addr)),
          (addressesStatus) => {
            if (this.humanizationId !== currentHumanizationId) return

            for (const call of this.humanization) {
              if (!call.fullVisualization) continue

              for (const vis of call.fullVisualization) {
                if (
                  (vis.type === 'token' || vis.type === 'address') &&
                  vis.address &&
                  addressesStatus[vis.address]
                ) {
                  vis.verification = addressesStatus[vis.address]
                }
              }
            }
            this.emitUpdate()
          }
        )
        .finally(() => {
          this.#updateBlacklistedStatusPromise = undefined
          this.updateStatus()
        })
    }
    this.emitUpdate()
  }

  learnTokens() {
    const additionalHints: GetOptions['additionalErc20Hints'] = this.humanization
      .map((call: any) =>
        !call.fullVisualization
          ? []
          : call.fullVisualization.map((vis: any) =>
              vis.address && isAddress(vis.address) ? getAddress(vis.address) : ''
            )
      )
      .flat()
      .filter((x: any) => isAddress(x))
    this.#portfolio.addTokensToBeLearned(additionalHints, this.#network.chainId)
  }

  get isInitialized(): boolean {
    return this.estimation && this.estimation.isInitialized()
  }

  async #loadFeeSelectionPreferences() {
    try {
      this.#feeSelectionPreferences = await this.#storage.get('feeSelectionPreferences', {})
    } catch (e: any) {
      // A missing preference only costs the user one extra tap, so never let
      // a storage failure block the signing flow.
      this.#feeSelectionPreferences = {}
      this.emitError({
        level: 'silent',
        message: 'Failed to load the last used fee payment selection',
        error: e
      })
    }
  }

  get #storedFeeSelectionPreference(): FeeSelectionPreference | undefined {
    if (!this.#feeSelectionPreferences) return undefined

    return this.#feeSelectionPreferences[
      getFeeSelectionPreferenceKey(this.accountOp.accountAddr, this.accountOp.chainId)
    ]
  }

  /**
   * Stores what the user just picked in the "Pay fee with" section. The fee
   * option and the fee speed are merged into the stored record separately,
   * because changing one must not overwrite the other.
   */
  async #persistFeeSelectionPreference(preference: FeeSelectionPreference) {
    // Otherwise a write that lands before the initial read would wipe the
    // preferences of all the other accounts/networks.
    await this.#feeSelectionPreferencesLoadPromise

    const merged = { ...this.#storedFeeSelectionPreference, ...preference }

    if (areFeeSelectionPreferencesEqual(this.#storedFeeSelectionPreference, merged)) return

    const key = getFeeSelectionPreferenceKey(this.accountOp.accountAddr, this.accountOp.chainId)
    this.#feeSelectionPreferences = { ...(this.#feeSelectionPreferences || {}), [key]: merged }

    try {
      await this.#storage.set('feeSelectionPreferences', this.#feeSelectionPreferences)
    } catch (e: any) {
      this.emitError({
        level: 'silent',
        message: 'Failed to store the last used fee payment selection',
        error: e
      })
    }
  }

  /**
   * Pre-selects the fee option the user picked the last time they signed on
   * this account + network. Returns false when there is nothing (valid) to
   * restore, in which case the caller applies the default selection.
   */
  #restoreFeeOptionPreference(): boolean {
    if (this.#hasResolvedFeeOptionPreference || this.#hasUserSelectedFeeOption) return false

    // A speed-up must reuse the fee payment of the transaction it replaces.
    if (this.isSpeedUpTransaction) return false

    // Preferences aren't read from storage yet - retry on the next update.
    if (!this.#feeSelectionPreferences) return false

    const preference = this.#storedFeeSelectionPreference?.option

    if (!preference) {
      this.#hasResolvedFeeOptionPreference = true
      return false
    }

    const option = findFeeOptionByPreference(this.estimation.availableFeeOptions, preference)

    // The fee speeds of the option are still unknown (a missing native/fee
    // token price ratio, for instance). Retry on the next update instead of
    // discarding the preference as unaffordable.
    if (option && !this.hasSpeeds(getFeeSpeedIdentifier(option, this.accountOp.accountAddr)))
      return false

    // Whatever happens below, this is the only chance to restore: either the
    // preference is applied, or it's stale and the default takes over.
    this.#hasResolvedFeeOptionPreference = true

    // The token may be gone from the portfolio, may no longer cover the fee,
    // or the payer may have been removed - fall back to the default in all
    // of those cases instead of pre-selecting something unusable.
    if (!option || this.#getIsFeeOptionDisabled(option)) return false

    // Safe accounts can only be broadcast by one of their EOA signers.
    if (!!this.account.safeCreation && option.paidBy === this.accountOp.accountAddr) return false

    this.feeTokenResult = option.token
    this.#paidBy = option.paidBy

    return true
  }

  /**
   * Pre-selects the fee speed the user picked last time, if that speed is
   * available and affordable for the fee option in use. Returns false so the
   * caller falls back to the default speed otherwise.
   *
   * The speed is restored independently of the fee option: a preferred speed
   * stays meaningful even when the preferred token is gone.
   */
  #restoreFeeSpeedPreference(feePaymentOption: FeePaymentOption): boolean {
    if (this.isSpeedUpTransaction) return false

    const speed = this.#storedFeeSelectionPreference?.speed
    if (!speed) return false

    const identifier = getFeeSpeedIdentifier(feePaymentOption, this.account.addr)
    const preferred = this.feeSpeeds[identifier]?.find(({ type }) => type === speed)

    if (!preferred || preferred.disabled) return false

    this.selectedFeeSpeed = speed

    return true
  }

  #setDefaults() {
    // Set the first signer as the default one.
    // If there are more available signers, the user will be able to select a different signer from the application.
    // The main benefit of having a default signer
    // is that it drastically simplifies the logic of determining whether the account is ready for signing.
    // For example, in the `sign` method and on the application screen, we can simply rely on the `this.readyToSign` flag.
    // Otherwise, if we don't have a default value, then `this.readyToSign` will always be false unless we set a signer.
    // In that case, on the application, we want the "Sign" button to be clickable/enabled,
    // and we have to check and expose the `SignAccountOp` controller's inner state to make this check possible.
    if (
      this.accountKeyStoreKeys.length &&
      (!this.accountOp.signingKeyAddr || !this.accountOp.signingKeyType)
    ) {
      // always try to select the hotkey, if any, as default
      // as the ui doesn't need to switch if the user doesn't need to
      const hotKey = this.accountKeyStoreKeys.find((k) => k.type === 'internal')
      const defaultKey = hotKey ?? this.accountKeyStoreKeys[0]!
      this.#updateAccountOp({
        signingKeyAddr: defaultKey.addr,
        signingKeyType: defaultKey.type
      })
    }

    if (this.estimation.status === EstimationStatus.Success && this.gasPrices) {
      this.#updateFeeSpeeds() // needed for the logic below

      const payOptionsPaidByUsOrGasTank = this.estimation.availableFeeOptions
        .filter((feeOption) => feeOption.paidBy === this.accountOp.accountAddr)
        .sort(this.#sortFeeOptions.bind(this))

      const payOptionsPaidByEOA = this.estimation.availableFeeOptions
        .filter((feeOption) => feeOption.paidBy !== this.accountOp.accountAddr)
        .sort(this.#sortFeeOptions.bind(this))

      // Pre-select the fee option the user last chose for this account +
      // network. It runs before the check below because the defaults may have
      // already been applied on an earlier update, while the preferences were
      // still being read from storage.
      const hasRestoredPreference = this.#restoreFeeOptionPreference()

      // Set default feeToken and paidBy
      if (!hasRestoredPreference && !this.feeTokenResult && !this.#paidBy) {
        // for Safe accounts, always select the first not disabled EOA
        // or the first EOA if all are disabled
        if (!!this.account.safeCreation && payOptionsPaidByEOA.length) {
          const notDisabled = payOptionsPaidByEOA.find(
            (option) => !this.#getIsFeeOptionDisabled(option)
          )
          const selected = notDisabled ?? payOptionsPaidByEOA[0]!
          this.feeTokenResult = selected.token
          this.#paidBy = selected.paidBy
        } else if (
          payOptionsPaidByUsOrGasTank.length > 0 &&
          !this.#getIsFeeOptionDisabled(payOptionsPaidByUsOrGasTank[0]!)
        ) {
          this.feeTokenResult = payOptionsPaidByUsOrGasTank[0]!.token
          this.#paidBy = payOptionsPaidByUsOrGasTank[0]!.paidBy
        } else if (
          payOptionsPaidByEOA.length > 0 &&
          !this.#getIsFeeOptionDisabled(payOptionsPaidByEOA[0]!)
        ) {
          this.feeTokenResult = payOptionsPaidByEOA[0]!.token
          this.#paidBy = payOptionsPaidByEOA[0]!.paidBy
        } else if (payOptionsPaidByUsOrGasTank.length) {
          this.feeTokenResult = payOptionsPaidByUsOrGasTank[0]!.token
          this.#paidBy = payOptionsPaidByUsOrGasTank[0]!.paidBy
        } else if (payOptionsPaidByEOA.length) {
          this.feeTokenResult = payOptionsPaidByEOA[0]!.token
          this.#paidBy = payOptionsPaidByEOA[0]!.paidBy
        }
      }
    }
  }

  #setGasFeePayment(paidByKeyType?: Key['type']) {
    if (
      this.isInitialized &&
      this.#paidBy &&
      this.selectedFeeSpeed &&
      this.feeTokenResult &&
      this.selectedOption
    ) {
      this.#updateAccountOp({
        gasFeePayment: this.#getGasFeePayment(paidByKeyType)
      })
    }
  }

  // check if speeds are set for the given identifier
  hasSpeeds(identifier: string) {
    return this.feeSpeeds[identifier] !== undefined && this.feeSpeeds[identifier].length
  }

  get errors(): SignAccountOpError[] {
    // no errors on a signed txn
    if (this.status?.type === SigningStatus.Queued) return []

    const accountOpValidationError = this.#validateAccountOp()

    if (accountOpValidationError) return [accountOpValidationError]

    const errors: SignAccountOpError[] = []

    const estimationErrors = this.estimation.errors
    if (estimationErrors.length) return estimationErrors

    const isAmbireV1 = isAmbireV1LinkedAccount(this.account?.creation?.factoryAddr)
    const isAmbireV1AndNetworkNotSupported = isAmbireV1 && !hasRelayerSupport(this.#network)

    // This must be the first error check!
    if (isAmbireV1AndNetworkNotSupported) {
      errors.push({
        title:
          'ZKX v1 accounts are not supported on this network. To interact with this network, please use a Smart Account or an EOA account. You can still use v1 accounts on any network that is natively integrated with the ZKX web and mobile wallets.'
      })

      // Don't show any other errors
      return errors
    }

    /**
     * A big block for logic separation
     * The above errors (estimation & ambireV1) are okay to be shown
     * even if isInitialized hasn't completed. Otherwise, do not load
     * any errors
     */
    if (!this.isInitialized) return []

    const areGasPricesLoading = typeof this.gasPrices === 'undefined'

    if (!areGasPricesLoading && !this.gasPrices && this.canBroadcast) {
      errors.push({
        title:
          'Gas price information is currently unavailable. This may be due to network congestion or connectivity issues. Please try again in a few moments or check your internet connection.'
      })
    }

    // availableFeeOptions normally always contains the account's native option,
    // so this mostly guards chains with neither a relayer nor a 4337 bundler
    // (ZKX: e.g. PulseChain pre-relayer), where a v2 account cannot broadcast a
    // self-paid op and all paidBy-self options are filtered out — with no EOA
    // able to cover the fee either, the list ends up empty
    if (!this.isSponsored && !this.estimation.availableFeeOptions.length && this.canBroadcast)
      errors.push({
        title: 'Insufficient funds to cover the fee.'
      })

    // if the Safe txn is not deployed, display an error
    const accountState =
      this.#accounts.accountStates[this.account.addr]?.[this.#network.chainId.toString()]
    if (!!this.account.safeCreation && accountState && !accountState.isDeployed) {
      errors.push({
        title: `Safe not activated on ${this.#network.name}. Please activate it from Safe Global`
      })
    }

    // It may occur, only if there are no available signer.
    if (!this.accountOp.signingKeyType || !this.accountOp.signingKeyAddr)
      errors.push({
        title: 'No keys available to sign this transaction.',
        code: 'NO_KEYS_AVAILABLE'
      })

    const currentPortfolio = this.#portfolio.getAccountPortfolioState(this.accountOp.accountAddr)
    const currentPortfolioNetwork = currentPortfolio[this.accountOp.chainId.toString()]

    const currentPortfolioNetworkNative = currentPortfolioNetwork?.result?.tokens.find(
      (token) => token.address === ZeroAddress
    )
    if (!this.isSponsored && !currentPortfolioNetworkNative && this.canBroadcast)
      errors.push({
        title:
          'Unable to estimate the transaction fee as fetching the latest price update for the network native token failed. Please try again later.'
      })

    // if there's no gasFeePayment calculate but there is: 1) feeTokenResult
    // 2) selectedOption and 3) gasSpeeds for selectedOption => return an error
    if (
      !this.isSponsored &&
      !this.accountOp.gasFeePayment &&
      this.feeTokenResult &&
      this.selectedOption &&
      this.canBroadcast
    ) {
      const identifier = getFeeSpeedIdentifier(this.selectedOption, this.accountOp.accountAddr)
      if (
        this.hasSpeeds(identifier) &&
        !this.#shouldSuppressTransferFeeSelectionError(this.selectedOption)
      )
        errors.push({
          title: 'Please select a token and an account for paying the gas fee.'
        })
    }

    if (
      !this.isSponsored &&
      this.selectedOption &&
      this.accountOp.gasFeePayment &&
      this.selectedOption.availableAmount < this.accountOp.gasFeePayment.amount &&
      !this.#shouldSuppressTransferFeeSelectionError(this.selectedOption) &&
      this.canBroadcast
    ) {
      const speedCoverage = []
      const identifier = getFeeSpeedIdentifier(this.selectedOption, this.accountOp.accountAddr)

      if (this.feeSpeeds[identifier]) {
        this.feeSpeeds[identifier].forEach((speed) => {
          if (this.selectedOption && this.selectedOption.availableAmount >= speed.amount)
            speedCoverage.push(speed.type)
        })
      }

      if (speedCoverage.length === 0 && !!this.account.safeCreation) {
        errors.push({
          title:
            this.selectedOption.paidBy === this.account.addr
              ? 'Broadcasting transactions is possible only using an external account. Import or create one to broadcast your Safe transactions'
              : ERRORS.eoaInsufficientFunds
        })
      } else if (speedCoverage.length === 0) {
        const isSA = isSmartAccount(this.account)
        const isUnableToCoverWithAllOtherTokens = this.estimation.availableFeeOptions.every(
          (option) => {
            if (option === this.selectedOption) return true
            const optionIdentifier = getFeeSpeedIdentifier(option, this.accountOp.accountAddr)

            const speedsThatCanCover = this.feeSpeeds[optionIdentifier]?.filter(
              (speed) => speed.amount <= option.availableAmount
            )

            return !speedsThatCanCover?.length
          }
        )
        if (isUnableToCoverWithAllOtherTokens) {
          // v1 acc handle
          const state =
            this.#accounts.accountStates[this.account.addr]?.[this.#network.chainId.toString()]
          const isV1 = this.account.creation && !state?.isV2
          if (isV1) {
            errors.push({
              title:
                'Broadcasting ZKX v1 transactions is possible only by using an EOA. Import or create one to broadcast your transactions.'
            })
          } else {
            let skippedTokensCount = 0
            const gasTokenNames = gasTankFeeTokens
              .filter(({ chainId, hiddenOnError }) => {
                if (chainId !== this.accountOp.chainId) return false

                if (hiddenOnError) {
                  skippedTokensCount++
                  return false
                }

                return true
              })
              .map(({ symbol }) => symbol.toUpperCase())
              .join(', ')

            errors.push({
              title: `${ERRORS.eoaInsufficientFunds}${
                isSA
                  ? ` Available fee options: USDC in Gas Tank, ${gasTokenNames}${
                      skippedTokensCount ? ' and others' : ''
                    }`
                  : ''
              }`
            })
          }
        } else {
          errors.push({
            title: isSA
              ? "Signing is not possible with the selected account's token as it doesn't have sufficient funds to cover the gas payment fee."
              : ERRORS.eoaInsufficientFunds
          })
        }
      } else {
        errors.push({
          title:
            'The selected speed is not available due to insufficient funds. Please select a slower speed.'
        })
      }
    }

    // The signing might fail, tell the user why but allow the user to retry signing,
    // @ts-ignore fix TODO: type mismatch
    if (this.status?.type === SigningStatus.ReadyToSign && !!this.status.error) {
      // @ts-ignore typescript complains, but the error being present gets checked above
      errors.push(this.status.error)
    }

    if (!this.isSponsored && !this.#feeSpeedsLoading && this.selectedOption && this.canBroadcast) {
      const identifier = getFeeSpeedIdentifier(this.selectedOption, this.accountOp.accountAddr)
      if (!this.hasSpeeds(identifier)) {
        if (!this.feeTokenResult?.priceIn.length) {
          errors.push({
            title: `Currently, ${this.feeTokenResult?.symbol} is unavailable as a fee token as we're experiencing troubles fetching its price. Please select another or contact support`
          })
        }
      }
    }

    // A v2 smart account signs the nonce into the op hash (getSignableHash ->
    // [addr, chainId, nonce, calls]), and the relayer path reads that nonce from
    // the chain with no awareness of ops still in flight. Two ops signed back to
    // back therefore carry the same nonce and at most one of them can ever
    // execute; the loser reverts with INSUFFICIENT_PRIVILEGE once the winner
    // bumps the nonce.
    //
    // We deliberately do not bump the nonce optimistically the way the 4337 path
    // does for pending user ops: `execute()` reverts as a whole when any call
    // reverts, so a failed op leaves the nonce untouched. A pre-signed op holding
    // nonce+1 would then be stranded forever. Blocking is the only safe option -
    // it clears by itself once the in-flight op mines or fails and leaves
    // `broadcastedButNotConfirmed`.
    //
    // A speed-up deliberately reuses the pending op's nonce to replace it, so it
    // is the one case where the collision is the point.
    if (
      this.accountOp.nonce !== null &&
      !this.isSpeedUpTransaction &&
      (this.#activity.broadcastedButNotConfirmed[this.account.addr] || []).some(
        (op) =>
          op.accountAddr === this.account.addr &&
          op.chainId === this.#network.chainId &&
          !op.asUserOperation &&
          isIdentifiedByRelayer(op.identifiedBy) &&
          op.nonce === this.accountOp.nonce
      )
    ) {
      errors.push({
        title:
          'You have a pending transaction on this network. Please wait for it to complete before signing another one.'
      })
    }

    // Safe txn, signed, with a future nonce: display an error
    if (
      !!this.account.safeCreation &&
      accountState &&
      this.accountOp.nonce &&
      this.accountOp.nonce !== accountState.nonce &&
      this.#accountOp.signed &&
      this.#accountOp.signed.length >= this.threshold
    ) {
      errors.push({
        title: 'You need to broadcast pending transactions before this one.'
      })
    }

    return errors
  }

  get readyToSign() {
    return (
      !!this.status &&
      (this.status?.type === SigningStatus.ReadyToSign ||
        this.status?.type === SigningStatus.UpdatesPaused ||
        this.status?.type === SigningStatus.Queued)
    )
  }

  calculateWarnings() {
    if (!this.isInitialized) return

    const warnings: Warning[] = []

    const state = this.#portfolio.getAccountPortfolioState(this.accountOp.accountAddr)

    const significantBalanceDecreaseWarning = getSignificantBalanceDecreaseWarning(
      state,
      this.accountOp.chainId,
      this.traceCallDiscoveryStatus
    )

    const unknownTokenWarnings = getUnknownTokenWarning(state, this.accountOp.chainId)

    if (this.selectedOption) {
      const identifier = getFeeSpeedIdentifier(this.selectedOption, this.accountOp.accountAddr)
      const feeTokenHasPrice = this.feeSpeeds[identifier]?.every((speed) => !!speed.amountUsd)
      const feeTokenPriceUnavailableWarning = getFeeTokenPriceUnavailableWarning(
        !!this.hasSpeeds(identifier),
        !!feeTokenHasPrice
      )

      // push the warning only if the txn is not sponsored
      if (!this.isSponsored && feeTokenPriceUnavailableWarning)
        warnings.push(feeTokenPriceUnavailableWarning)
    }

    if (significantBalanceDecreaseWarning) warnings.push(significantBalanceDecreaseWarning)
    if (unknownTokenWarnings) warnings.push(unknownTokenWarnings)

    // if 7702 EOA that is not ambire
    // and another delegation is there, show the warning
    const broadcastOption = this.selectedOption
      ? this.baseAccount.getBroadcastOption(this.selectedOption, {
          op: this.accountOp,
          isSponsored: this.isSponsored
        })
      : null
    if (
      'is7702' in this.baseAccount &&
      this.baseAccount.is7702 &&
      this.delegatedContract &&
      this.delegatedContract !== ZeroAddress &&
      this.delegatedContract?.toLowerCase() !== EIP_7702_AMBIRE_ACCOUNT.toLowerCase() &&
      this.delegatedContract?.toLowerCase() !== EIP_7702_GRID_PLUS.toLowerCase() &&
      this.delegatedContract?.toLowerCase() !== EIP_7702_KATANA.toLowerCase() &&
      this.delegatedContract?.toLowerCase() !== EIP_7702_AMBIRE_LEGACY.toLowerCase() &&
      (!this.accountOp.meta || this.accountOp.meta.setDelegation === undefined) &&
      (broadcastOption === BROADCAST_OPTIONS.byBundler ||
        broadcastOption === BROADCAST_OPTIONS.delegation) &&
      WARNINGS.delegationDetected
    ) {
      warnings.push(WARNINGS.delegationDetected)
    }

    const accountState =
      this.#accounts.accountStates[this.account.addr]?.[this.#network.chainId.toString()]
    if (this.account.creation && !accountState?.isV2 && WARNINGS.v1Acc)
      warnings.push(WARNINGS.v1Acc)

    const estimationWarnings = this.estimation.calculateWarnings()

    this.warnings = warnings.concat(estimationWarnings)

    this.emitUpdate()
  }

  /**
   * Updates the estimation and the portfolio simulation
   * for the current accountOp
   */
  async #simulateAndEstimate() {
    // Trace call the only if it hasn't been done yet for these calls
    const shouldTraceCall = this.traceCallDiscoveryStatus === TraceCallDiscoveryStatus.NotStarted
    // no simulation / estimation if we're in a signing state
    if (!this.canUpdate()) return

    if (shouldTraceCall) this.#traceCall()

    await Promise.all([
      this.#portfolio.simulateAccountOp(this.accountOp),
      this.estimation.estimate(this.accountOp).catch((e) => e)
    ])

    // calculate the warnings after the portfolio is fetched
    this.calculateWarnings()

    const estimation = this.estimation.estimation

    // estimation.flags.hasNonceDiscrepancy is a signal from the estimation
    // that we should update the portfolio to get a correct simulation
    if (estimation && estimation.ambireEstimation && estimation.flags.hasNonceDiscrepancy) {
      this.#updateAccountOp({
        nonce: BigInt(estimation.ambireEstimation.ambireAccountNonce)
      })
      await this.#portfolio.simulateAccountOp(this.accountOp)
    }

    // if the portfolio detects a nonce discrepancy and the estimation is a Success,
    // refetch the account state, resimulate and put the correct nonce in accountOp
    const portfolioState = this.#portfolio.getAccountPortfolioState(this.accountOp.accountAddr)
    const pendingPortfolioState = portfolioState
      ? portfolioState[this.accountOp.chainId.toString()]
      : null
    if (
      this.estimation.status === EstimationStatus.Success &&
      pendingPortfolioState &&
      pendingPortfolioState.criticalError?.simulationErrorMsg &&
      pendingPortfolioState.criticalError?.simulationErrorMsg.indexOf('nonce did not increment') !==
        -1
    ) {
      const pendingAccountState = await this.#accounts.forceFetchPendingState(
        this.accountOp.accountAddr,
        this.accountOp.chainId
      )
      this.#updateAccountOp({
        nonce: pendingAccountState.nonce
      })
      await this.#portfolio.simulateAccountOp(this.accountOp)
    }

    // if there's an estimation error, override the pending results
    if (this.estimation.status === EstimationStatus.Error) {
      await this.#portfolio.overrideSimulationResults(this.accountOp)
    }
  }

  /**
   * Either simulates+estimates or just estimates based on #shouldSimulate.
   * This is needed because in some cases (one click transfer/swap) we don't
   * need to simulate, just estimate.
   */
  async #simulateAndEstimateOrEstimate() {
    if (this.#stopRefetching || !this.estimation) return

    // the first 10 times, reestimate once every 30s; then, slow down
    // the time as the user might just have closed the popup of the extension
    // in a ready-to-estimate state, resulting in meaningless requests
    const waitTime =
      this.#reestimateCounter < 10 ? ESTIMATE_UPDATE_INTERVAL : 10000 * this.#reestimateCounter

    // Update the timeout for the next run
    this.#simulateAndEstimateOrSimulateInterval.updateTimeout({ timeout: waitTime })

    await (this.#shouldSimulate
      ? this.#simulateAndEstimate()
      : this.estimation.estimate(this.accountOp))

    if (this.#reestimateCounter >= 20) {
      this.#simulateAndEstimateOrSimulateInterval.stop()
      this.#gasPriceInterval.stop()
      this.#stopRefetching = true
    }

    this.#reestimateCounter += 1
  }

  /**
   * Refetches the gas price immediately and silently
   * (no errors emitted in case of failure). Also
   * restarts the gas price interval afterward.
   *
   * We can't simply restart the interval with runImmediately
   * because the interval is calling fetch() with a 'major' parameter
   */
  async #silentGasPriceUpdate() {
    this.#gasPriceInterval.stop()
    await this.gasPrice.fetch()
    this.#gasPriceInterval.restart()
  }

  async retry(method: 'simulate' | 'estimate') {
    this.bundlerSwitcher.cleanUp()
    this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true })
  }

  update({
    gasPrices,
    customGasPrices,
    customGasLimit,
    feeToken,
    paidBy,
    speed,
    signingKeyAddr,
    signingKeyType,
    signedTransactionsCount,
    hasNewEstimation,
    paidByKeyType,
    accountOpData
  }: SignAccountOpUpdateProps) {
    try {
      const isSpeedUpTransaction = this.isSpeedUpTransaction

      // This must be at the top, otherwise it won't be updated because
      // most updates are frozen during the signing process
      if (typeof signedTransactionsCount !== 'undefined') {
        this.signedTransactionsCount = signedTransactionsCount
        // If we add other exclusions we should figure out a way to emitUpdate only once
        this.emitUpdate()
        return
      }

      // once the user commits to the things he sees on his screen,
      // we need to be sure nothing changes afterwards.
      // For example, signing can be slow if it's done by a hardware wallet.
      // The estimation gets refreshed on the other hand each 12 seconds (6 on optimism)
      // If we allow the estimation to affect the controller state during sign,
      // there could be discrepancy between what the user has agreed upon and what
      // we broadcast in the end
      if (this.status?.type && noStateUpdateStatuses.indexOf(this.status?.type) !== -1) {
        return
      }

      if (this.estimation.status === EstimationStatus.Success) {
        // Start the gas price interval in case it was stopped earlier
        if (!this.hasCustomGasPrices) {
          this.#gasPriceInterval.start({
            // Refetch immediately if the gas prices are stale
            runImmediately:
              !this.gasPrice.updatedAt ||
              Date.now() - this.gasPrice.updatedAt > GAS_PRICE_UPDATE_INTERVAL
          })
        } else {
          this.#gasPriceInterval.stop()
        }

        const estimation = this.estimation.estimation as FullEstimationSummary
        if (estimation.ambireEstimation && !isSpeedUpTransaction) {
          this.#updateAccountOp({
            nonce: BigInt(estimation.ambireEstimation.ambireAccountNonce)
          })
        }
      } else if (this.estimation.status === EstimationStatus.Error) {
        // No need to update gasPrices if the estimation failed
        this.#gasPriceInterval.stop()
      }
      // if there's a bundler estimation and the gasPrice for it has resolved, update the UI
      if (this.estimation.estimation) {
        if (this.estimation.estimation.bundlerGasPrices) {
          // by transforming and setting the bundler gas prices as this.gasPrices, we accomplish two things:
          // 1. we no longer need to wait for the gasPrice controller to complete in order to refresh the UI
          // 2. we make sure we give priority to the bundler prices as they are generally better
          if (!this.hasCustomGasPrices) {
            this.gasPrices = this.estimation.estimation.bundlerGasPrices
          }
          // and we're stopping the gas price interval as
          // we will use the bundler gas prices
          this.#gasPriceInterval.stop()
          this.gasPrice.areGasPricesUsedFromBundlerEstimation = true
        } else {
          // if there's an estimate, but no bundlerGasPrices, resume the gas price
          // controller refetch as there's no other way to fetch gas prices
          if (!this.hasCustomGasPrices) {
            this.#gasPriceInterval.start({
              runImmediately:
                !this.gasPrice.updatedAt ||
                Date.now() - this.gasPrice.updatedAt > GAS_PRICE_UPDATE_INTERVAL
            })
          } else {
            this.#gasPriceInterval.stop()
          }
          this.gasPrice.areGasPricesUsedFromBundlerEstimation = false
        }
      }

      if (accountOpData && !isSpeedUpTransaction) {
        const { calls, signature, ...rest } = accountOpData

        if (signature && this.accountOp.txnId) {
          const newlySigned = getAlreadySignedOwners(
            signature,
            this.accountOp.txnId,
            this.accountOp.safeTx
          )
          const signed = this.accountOp.signed
            ? [...new Set(...this.accountOp.signed, ...newlySigned)]
            : newlySigned
          this.#updateAccountOp({
            signature: sortSigs(
              getSigs(signature),
              this.accountOp.txnId,
              this.accountOp.safeTx?.confirmations
            ),
            signed
          })
        }

        // update all properties except calls
        // calls are handled separately below
        this.#updateAccountOp(rest)

        if (Array.isArray(calls)) {
          // we should update if the arrays are with diff length
          let shouldUpdate = this.accountOp.calls.length !== calls.length

          if (!shouldUpdate) {
            // if they are with the same length, check if some of
            // their properties differ. If they do, we should update
            this.accountOp.calls.forEach((call, i) => {
              const newCall = calls[i]!
              if (
                call.to !== newCall?.to ||
                call.data !== newCall?.data ||
                call.value !== newCall?.value ||
                call.id !== newCall?.id
              )
                shouldUpdate = true
            })
          }

          // update only if there are differences in the calls array
          // we do this to prevent double estimation problems
          if (shouldUpdate) {
            const hasNewCalls = this.accountOp.calls.length < calls.length
            this.#updateAccountOp({ calls })
            this.humanize()

            if (hasNewCalls) {
              this.learnTokens()
              // Reset the discovery status when the calls change to allow
              // for rediscovery
              this.setDiscoveryStatus(TraceCallDiscoveryStatus.NotStarted)
            }
            this.#resumeIntervals({ haveCallsChanged: true })
          }
        }
      }

      if (customGasPrices) {
        this.gasPrices = customGasPrices
        this.hasCustomGasPrices = true
        this.#gasPriceInterval.stop()
      } else if (gasPrices && !this.hasCustomGasPrices) {
        this.gasPrices = gasPrices
      }

      // ZKX: a speed-up may never quote below the pending txn's own price
      this.#applySpeedUpGasPriceFloor()

      if (typeof customGasLimit !== 'undefined') {
        this.customGasLimit = customGasLimit
      }

      this.#syncSpeedUpFeeSelectionFromEstimation()

      if (feeToken && paidBy && !isSpeedUpTransaction) {
        this.#paidBy = paidBy
        this.feeTokenResult = feeToken
        // From here on the selection is the user's, so the stored preference
        // must neither override it nor be restored later in this session.
        this.#hasUserSelectedFeeOption = true
        this.#hasResolvedFeeOptionPreference = true
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.#persistFeeSelectionPreference({
          option: {
            paidBy,
            tokenAddress: feeToken.address,
            tokenSymbol: feeToken.symbol,
            isGasTank: !!feeToken.flags.onGasTank
          }
        })

        if (this.accountOp.gasFeePayment && this.accountOp.gasFeePayment.paidBy !== paidBy) {
          // Reset paidByKeyType if the payer has changed
          // A default value will be set in #setGasFeePayment
          this.accountOp.gasFeePayment.paidByKeyType = null
        }
      }

      // The fee speed stays selectable on a speed-up - it is the only lever the
      // user has to outbid the stuck txn (the fee TOKEN and payer do not,
      // `#syncSpeedUpFeeSelectionFromEstimation` pins those to the original).
      if (speed && this.isInitialized) {
        this.selectedFeeSpeed = speed
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.#persistFeeSelectionPreference({ speed })
      }

      if (signingKeyAddr && signingKeyType && this.isInitialized && !isSpeedUpTransaction) {
        this.#updateAccountOp({ signingKeyAddr, signingKeyType })

        // If the fee is paid by the signer, then we should set the fee payer
        // key type to the signing key type (so the user doesn't have to select
        // the same key type twice)
        if (this.accountOp.gasFeePayment?.paidBy === signingKeyAddr) {
          this.accountOp.gasFeePayment.paidByKeyType = signingKeyType
        }
      }

      // Set defaults, if some of the optional params are omitted
      this.#setDefaults()
      if (isSpeedUpTransaction) this.#syncSpeedUpFeeSelectionFromEstimation()

      if (
        this.estimation.status === EstimationStatus.Success &&
        this.#paidBy &&
        this.feeTokenResult
      ) {
        const selectedOption = this.estimation.availableFeeOptions.find(
          (option) =>
            option.paidBy === this.#paidBy &&
            option.token.address === this.feeTokenResult!.address &&
            option.token.symbol.toLocaleLowerCase() ===
              this.feeTokenResult!.symbol.toLocaleLowerCase() &&
            option.token.flags.onGasTank === this.feeTokenResult!.flags.onGasTank
        )
        // <Bobby>: trigger setting the real default speed just before
        // setting the first selectedOption. This way we know all the
        // necessary information like available amount for the selected
        // option so we could calculate the fee speed if he doesn't have
        // enough for fast but has enough for slow/medium
        if (selectedOption) this.#setDefaultFeeSpeed(selectedOption)
        this.selectedOption = selectedOption
      }

      if (
        this.estimation.estimation &&
        this.estimation.estimation.bundlerEstimation &&
        this.estimation.estimation.bundlerEstimation.paymaster
      ) {
        this.isSponsored = this.estimation.estimation.bundlerEstimation.paymaster.isSponsored()
        this.sponsor =
          this.estimation.estimation.bundlerEstimation.paymaster.getEstimationData()?.sponsor
      }

      // calculate the fee speeds if either there are no feeSpeeds
      // or any of properties for update is requested
      if (
        !Object.keys(this.feeSpeeds).length ||
        Array.isArray(accountOpData?.calls) ||
        gasPrices ||
        customGasPrices ||
        typeof customGasLimit !== 'undefined' ||
        this.#paidBy ||
        this.feeTokenResult ||
        hasNewEstimation
      ) {
        this.#updateFeeSpeeds()
      }

      // Here, we expect to have most of the fields set, so we can safely set GasFeePayment
      this.#setGasFeePayment(paidByKeyType)
      this.updateStatus()
      this.calculateWarnings()
    } catch (e: any) {
      this.emitError({
        message: 'Error updating the SignAccountOpController',
        error: e,
        level: 'silent'
      })
    }
  }

  updateStatus(forceStatusChange?: SigningStatus, replacementFeeLow = false) {
    // use this to go back to ReadyToSign when a broadcasting error is emitted
    if (forceStatusChange) {
      // Clean up hardware wallet signing when cancelling an in-progress signing
      if (
        forceStatusChange === SigningStatus.ReadyToSign &&
        this.status?.type === SigningStatus.InProgress
      ) {
        this.#hwCleanup()
        // Clear the promises so user can retry signing
        this.signPromise = undefined
        this.signAndBroadcastPromise = undefined
        this.broadcastPromise = undefined
      }
      this.status = { type: forceStatusChange }
      this.emitUpdate()
      return
    }

    // no status updates on these two
    const isInTheMiddleOfSigning =
      this.status?.type === SigningStatus.InProgress ||
      this.status?.type === SigningStatus.WaitingForPaymaster
    const isDone = this.status?.type === SigningStatus.Done

    if (isInTheMiddleOfSigning || isDone) return

    // if we have an estimation error, set the state so and return
    if (this.estimation.error) {
      this.status = { type: SigningStatus.EstimationError }
      this.emitUpdate()
      return
    }

    if (this.errors.length) {
      this.status = { type: SigningStatus.UnableToSign }
      this.emitUpdate()
      return
    }

    // change the status to SigningStatus.Queued if there are no
    // available signers to sign
    if (this.#accountOp.signature && this.#accountOp.txnId) {
      this.#accountOp.signed = getAlreadySignedOwners(
        this.#accountOp.signature,
        this.#accountOp.txnId,
        this.#accountOp.safeTx
      )
      const notSigned = getImportedSignersThatHaveNotSigned(
        this.#accountOp.signed,
        this.accountKeyStoreKeys.map((k) => k.addr)
      )
      if (this.#accountOp.signed.length < this.threshold && !notSigned.length) {
        this.status = { type: SigningStatus.Queued }
        this.emitUpdate()
        return
      }
    }

    if (
      this.isInitialized &&
      this.accountOp.signingKeyAddr &&
      this.accountOp.signingKeyType &&
      this.accountOp.gasFeePayment
    ) {
      this.status = { type: SigningStatus.ReadyToSign }

      // do not reset this once triggered
      if (replacementFeeLow) this.replacementFeeLow = replacementFeeLow
      this.emitUpdate()
      return
    }

    // reset the status if a valid state was not found
    this.status = null
    this.emitUpdate()
  }

  destroy() {
    super.destroy()
    // Stop intervals
    this.#simulateAndEstimateOrSimulateInterval.stop()
    this.#gasPriceInterval.stop()
    this.#stopRefetching = true
    // Destroy sub-controllers
    this.estimation.destroy()
    this.gasPrice.destroy()
    this.#onDappsUpdateUnsubscribe?.()
    this.#onDappsUpdateUnsubscribe = undefined
    // Other cleanup
    this.#hwCleanup()
    this.gasPrices = undefined
    this.hasCustomGasPrices = false
    this.#speedUpGasPriceFloor = null
    this.selectedFeeSpeed = FeeSpeed.Fast
    this.#paidBy = null
    this.feeTokenResult = null
    this.status = null
    this.signedTransactionsCount = null
    this.hardwareWalletSigningRequest = null
  }

  #getDappVerificationBanner(): SignAccountOpBanner | null {
    const dappUrls = this.accountOp.calls
      .map((call) => call.dapp?.url?.toLowerCase())
      .filter((url): url is string => !!url)

    if (!dappUrls.length) return null

    const dappVerificationBanner = this.#dapps.getDappVerificationBanner(dappUrls)
    if (!dappVerificationBanner) return null

    const containsPermit2 = this.accountOp.calls.some((call) => {
      if (!call.to || !call.data) return false
      return isPermit2Interaction({ to: call.to, data: call.data })
    })

    // Show the "not in catalog" banner only for Permit2 interactions to reduce noise on lower-risk actions.
    if (
      !containsPermit2 &&
      dappVerificationBanner.id === DAPP_VERIFICATION_BANNER_IDS.NOT_IN_CATALOG
    ) {
      return null
    }

    return dappVerificationBanner
  }

  /**
   * Makes the signAccountOp controller inactive:
   * - Stops all refetching (estimation, gas price)
   * - Unregisters from the controller registry, which in turn stops all emit updates
   * to the UI
   * This is done so there is always only one signAccountOp controller active at a time,
   * and only one controller in the registry (so the UI listens to the active one only).
   */
  pause() {
    this.#stopIntervals()
    this.unregisterFromRegistry()
  }

  #stopIntervals() {
    this.#stopRefetching = true
    // GasPrice may be destroyed at this point if the request was rejected
    this.#gasPriceInterval.stop()
    this.#simulateAndEstimateOrSimulateInterval.stop()
  }

  /**
   * Resumes the intervals of the signAccountOp controller, which may be paused
   * due to user inactivity or the controller being paused altogether.
   *
   * Also used to restart the intervals when the calls have changed.
   * That is because they may be stopped (after inactivity).
   */
  #resumeIntervals(opts?: { haveCallsChanged?: boolean }) {
    const { haveCallsChanged = false } = opts || {}

    // we want to restart the interval if signAccountOp is for a signed Safe.
    // the reason for this: there could be multiple signed Safe txns with
    // the same nonce waiting to be broadcast. The may want to check each
    // out in quick succession. If he does 1 -> 2 -> 1, calls would not
    // have changed on 1, but the simulation from 2 will persist as sadly,
    // the simulation is account based, not accountOp based
    const isSignedSafe = !!this.account.safeCreation && !!this.accountOp.signed?.length

    this.#stopRefetching = false
    this.#reestimateCounter = 0

    this.#gasPriceInterval.start({
      runImmediately:
        !this.gasPrice.updatedAt || Date.now() - this.gasPrice.updatedAt > GAS_PRICE_UPDATE_INTERVAL
    })

    if (haveCallsChanged || isSignedSafe) {
      // The simulateAndEstimateOrSimulateInterval must be restarted if the calls have changed
      // as that forces an immediate reestimation. start() does nothing
      // if the interval is already running.
      this.#simulateAndEstimateOrSimulateInterval.restart({
        runImmediately: true,
        // This must be true. Otherwise a pending estimation
        // will prevent a new estimation from being made
        // which is a must since the calls have changed
        allowOverlap: true
      })
    } else {
      this.#simulateAndEstimateOrSimulateInterval.start({
        runImmediately:
          !this.estimation.estimation?.updatedAt ||
          Date.now() - this.estimation.estimation!.updatedAt > ESTIMATE_UPDATE_INTERVAL
      })
    }
  }

  /**
   * Resumes updates and intervals for the signAccountOp controller.
   *
   * Also registers the controller in the controller registry.
   */
  resume() {
    this.registerInRegistry()
    this.#resumeIntervals()

    this.emitUpdate()
  }

  resetStatus() {
    this.status = null
    this.emitUpdate()
  }

  #sortFeeOptions(a: FeePaymentOption, b: FeePaymentOption) {
    const aId = getFeeSpeedIdentifier(a, this.accountOp.accountAddr)
    const aSlow = this.feeSpeeds[aId]?.find((speed) => speed.type === 'slow')
    if (!aSlow) return 1
    const aCanCoverFee = canFeeOptionCoverAmount(a, this.accountOp, aSlow.amount)

    const bId = getFeeSpeedIdentifier(b, this.accountOp.accountAddr)
    const bSlow = this.feeSpeeds[bId]?.find((speed) => speed.type === 'slow')
    if (!bSlow) return -1
    const bCanCoverFee = canFeeOptionCoverAmount(b, this.accountOp, bSlow.amount)

    if (aCanCoverFee && !bCanCoverFee) return -1
    if (!aCanCoverFee && bCanCoverFee) return 1

    // gas tank first
    if (a.token.flags.onGasTank && !b.token.flags.onGasTank) return -1
    if (!a.token.flags.onGasTank && b.token.flags.onGasTank) return 1

    // native second
    if (a.token.address === ZERO_ADDRESS && b.token.address !== ZERO_ADDRESS) return -1
    if (a.token.address !== ZERO_ADDRESS && b.token.address === ZERO_ADDRESS) return 1

    if (!a || !b) return 0

    const aPrice = a.token?.priceIn?.[0]?.price
    const bPrice = b.token?.priceIn?.[0]?.price
    if (aPrice && !bPrice) return -1
    if (!aPrice && bPrice) return 1

    return 0
  }

  #getIsFeeOptionDisabled(feeOption: FeePaymentOption): boolean {
    const id = getFeeSpeedIdentifier(feeOption, this.accountOp.accountAddr)
    const speeds = this.feeSpeeds[id] ?? []
    const isTransferredTokenOption = isTransferredTokenFeeOption(feeOption, this.accountOp)

    const coversSlow = speeds.some(
      (speed: SpeedCalc) =>
        speed.type === FeeSpeed.Slow && feeOption.availableAmount >= speed.amount
    )

    if (!coversSlow && !isTransferredTokenOption) return true

    const isExternal = this.accountKeyStoreKeys.some(
      (keyStoreKey) => keyStoreKey.addr === feeOption.paidBy && keyStoreKey.isExternallyStored
    )

    const canNotBecomeSmarter = !canBecomeSmarter(this.account, this.accountKeyStoreKeys)

    if (isExternal && canNotBecomeSmarter && feeOption.token.address !== ZERO_ADDRESS) return true

    return false
  }

  #shouldSuppressTransferFeeSelectionError(feeOption?: FeePaymentOption): boolean {
    return (
      this.#type === 'one-click-transfer' &&
      !!feeOption &&
      isTransferredTokenFeeOption(feeOption, this.accountOp)
    )
  }

  /**
   * Obtain the native token ratio in relation to a fee token.
   *
   * By knowing the USD value of the tokens in the portfolio,
   * we can calculate the ratio between a native token and a fee token.
   *
   * For example, 1 ETH = 8 BNB (ratio: 8).
   *
   * We require the ratio to be in a BigInt format since all the application values,
   * such as amount, gasLimit, etc., are also represented as BigInt numbers.
   */
  #getNativeToFeeTokenRatio(feeToken: TokenResult): bigint | null {
    const native = this.#portfolio
      .getAccountPortfolioState(this.accountOp.accountAddr)
      [
        this.accountOp.chainId.toString()
      ]?.result?.tokens.find((token) => token.address === ZeroAddress)
    if (!native) return null

    // In case the fee token is the native token we don't want to depend to priceIn, as it might not be available.
    if (native.address === feeToken.address && native.chainId === feeToken.chainId)
      return BigInt(1 * 1e18)

    const isUsd = (price: Price) => price.baseCurrency === 'usd'

    const nativePrice = native.priceIn.find(isUsd)?.price
    const feeTokenPrice = feeToken.priceIn.find(isUsd)?.price

    if (!nativePrice || !feeTokenPrice) return null

    const ratio = nativePrice / feeTokenPrice

    // Here we multiply it by 1e18, in order to keep the decimal precision.
    // Otherwise, passing the ratio to the BigInt constructor, we will lose the numbers after the decimal point.
    // Later, once we need to normalize this ratio, we should not forget to divide it by 1e18.
    const ratio1e18 = ratio * 1e18
    const toBigInt = ratio1e18 % 1 === 0 ? ratio1e18 : ratio1e18.toFixed(0)
    return BigInt(toBigInt)
  }

  async #traceCall() {
    // `traceCall` should not be invoked too frequently. However, if there is a pending timeout,
    // it should be cleared to prevent the previous interval from changing the status
    // to `SlowPendingResponse` for the newer `traceCall` invocation.
    if (this.#traceCallTimeoutId) clearTimeout(this.#traceCallTimeoutId)

    // Here, we also check the status because, in the case of re-estimation,
    // `traceCallDiscoveryStatus` is already set, and we don’t want to reset it to "InProgress".
    // This prevents the BalanceDecrease banner from flickering.
    if (this.traceCallDiscoveryStatus === TraceCallDiscoveryStatus.NotStarted)
      this.setDiscoveryStatus(TraceCallDiscoveryStatus.InProgress)

    // Flag the discovery logic as `SlowPendingResponse` if the call does not resolve within 2 seconds.
    const timeoutId = setTimeout(() => {
      this.setDiscoveryStatus(TraceCallDiscoveryStatus.SlowPendingResponse)
      this.calculateWarnings()
    }, 2000)

    this.#traceCallTimeoutId = timeoutId

    try {
      const state =
        this.#accounts.accountStates[this.account.addr]?.[this.#network.chainId.toString()]
      // TODO: how to handle this case?
      if (!state) return
      let erc20s: string[] = []
      let erc721s: [string, bigint[]][] = []

      const stateOverride = getStateOverride(this.account, this.accountOp, state)
      const shouldUseAccessList = getShouldUseAccessListCall(this.account, !!stateOverride)
      let accessListFailed = false

      if (shouldUseAccessList) {
        console.log('Debug: using eth_createAccessList for asset discovery')
        const addresses = await createAccessListCall(
          this.baseAccount,
          this.accountOp,
          this.#network,
          state
        ).catch((e) => {
          this.emitError({
            level: 'silent',
            message: 'Error in signAccountOp.traceCall',
            error: e
          })
          accessListFailed = true
          return null
        })
        if (addresses) {
          erc20s = addresses
          erc721s = addresses.map((address) => [address, []])
        }
      }
      if (!shouldUseAccessList || accessListFailed) {
        console.log('Debug: using debug_traceCall for asset discovery')
        const { tokens, nfts } = await debugTraceCall(
          this.baseAccount,
          this.accountOp,
          this.#network,
          state,
          stateOverride
        )
        erc20s = tokens
        erc721s = nfts
      }

      const learnedNewTokens = this.#portfolio.addTokensToBeLearned(erc20s, this.#network.chainId)
      const learnedNewNfts = this.#portfolio.addErc721sToBeLearned(
        erc721s,
        this.account.addr,
        this.#network.chainId
      )

      if (this.canUpdate() && (learnedNewTokens || learnedNewNfts)) {
        !!this.#onUpdateAfterTraceCallSuccess && (await this.#onUpdateAfterTraceCallSuccess())
      }

      this.setDiscoveryStatus(TraceCallDiscoveryStatus.Done)
    } catch (e: any) {
      this.setDiscoveryStatus(TraceCallDiscoveryStatus.Failed)

      this.emitError({
        level: 'silent',
        message: 'Error in signAccountOp.traceCall',
        error: e
      })
    }

    this.calculateWarnings()
    this.#traceCallTimeoutId = null
    clearTimeout(timeoutId)
  }

  #addExtra(gasInWei: bigint, percentageIncrease: bigint): Hex {
    const percent = 100n / percentageIncrease
    return toBeHex(gasInWei + gasInWei / percent) as Hex
  }

  /**
   * What is a good UX?
   * In the 4337 broadcast model, fee speeds don't make sense. That is
   * because it doesn't matter if you choose slow or fast, if the bundler
   * accepts the userOp, he is obliged to broadcast it as soon as possible.
   * Also, some bundlers return a single value for gas prices, meaning all
   * speed options should have the same cost
   *
   * But Ethereum UX doesn't work liket this.
   * Users expect to see a broadcast speed in the wallet itself and if
   * it's not present, they will find it strange.
   *
   * The soluiton here is to create the illusion of speeds in the 4337
   * broadcast model by increasing them only for the user payment but
   * using the original, bundler provided ones for broadcast.
   * That way we get a better bundler userOp acceptance rate and a
   * normal, intuitive UX
   */
  #getIncreasedPrices(): GasSpeeds | null {
    if (!this.gasPrices) return null

    // no increase if the user has set them
    if (this.hasCustomGasPrices) return this.gasPrices

    return {
      slow: {
        maxFeePerGas: this.#addExtra(BigInt(this.gasPrices.slow.maxFeePerGas), 5n),
        maxPriorityFeePerGas: this.#addExtra(BigInt(this.gasPrices.slow.maxPriorityFeePerGas), 5n)
      },
      medium: {
        maxFeePerGas: this.#addExtra(BigInt(this.gasPrices.medium.maxFeePerGas), 7n),
        maxPriorityFeePerGas: this.#addExtra(BigInt(this.gasPrices.medium.maxPriorityFeePerGas), 7n)
      },
      fast: {
        maxFeePerGas: this.#addExtra(BigInt(this.gasPrices.fast.maxFeePerGas), 10n),
        maxPriorityFeePerGas: this.#addExtra(BigInt(this.gasPrices.fast.maxPriorityFeePerGas), 10n)
      },
      ape: {
        maxFeePerGas: this.#addExtra(BigInt(this.gasPrices.ape.maxFeePerGas), 20n),
        maxPriorityFeePerGas: this.#addExtra(BigInt(this.gasPrices.ape.maxPriorityFeePerGas), 20n)
      }
    }
  }

  get #feeSpeedsLoading() {
    return !this.isInitialized || !this.gasPrices
  }

  #setDefaultFeeSpeed(feePaymentOption: FeePaymentOption) {
    // don't update if an option is already set
    if (this.selectedOption) return

    const identifier = getFeeSpeedIdentifier(feePaymentOption, this.account.addr)
    const speeds = this.feeSpeeds[identifier]
    if (!speeds) return

    // the speed the user picked last time wins over the default below, as
    // long as it's still available and affordable for this fee option
    if (this.#restoreFeeSpeedPreference(feePaymentOption)) return

    // set fast if available
    if (speeds.find(({ type, disabled }) => type === FeeSpeed.Fast && !disabled)) {
      this.selectedFeeSpeed = FeeSpeed.Fast
      return
    }

    // set at least slow
    const fastestEnabledSpeed = [...speeds].reverse().find(({ disabled }) => !disabled)
    this.selectedFeeSpeed = fastestEnabledSpeed?.type || FeeSpeed.Slow
  }

  #updateFeeSpeeds() {
    if (this.estimation.status !== EstimationStatus.Success || !this.gasPrices) return

    const estimation = this.estimation.estimation as FullEstimationSummary

    // reset the fee speeds at the beginning to avoid duplications
    this.feeSpeeds = {}

    this.estimation.availableFeeOptions.forEach((option) => {
      // if a calculation has been made, do not make it again
      // EOA pays for SA is the most common case for this scenario
      const identifier = getFeeSpeedIdentifier(option, this.accountOp.accountAddr)
      if (this.hasSpeeds(identifier)) {
        return
      }

      const nativeRatio = this.#getNativeToFeeTokenRatio(option.token)
      const increasedGasPrices = this.#getIncreasedPrices()
      if (!nativeRatio || !this.gasPrices || !increasedGasPrices) {
        this.feeSpeeds[identifier] = []
        return
      }

      // get the gas used for each payment option
      const gasUsed = this.baseAccount.getGasUsed(estimation, {
        feeToken: option.token,
        op: this.accountOp
      })

      // each available fee option should declare it's estimation method
      const broadcastOption = this.baseAccount.getBroadcastOption(option, {
        op: this.accountOp,
        isSponsored: this.isSponsored
      })

      const speeds = ['slow', 'medium', 'fast', 'ape']
      for (let i = 0; i < speeds.length; i++) {
        // we have two prices:
        // receivedPrices, from old lib/bundler
        // and increasedPrices, which we use for the fee only
        const speed = speeds[i] as FeeSpeed
        const receivedPrices = this.gasPrices[speed]
        const increasedPrices = increasedGasPrices[speed]

        let amount
        let simulatedGasLimit: bigint
        let gasPrice
        let maxPriorityFeePerGas
        let amountGasPrice: bigint
        let usesPaymaster = false

        if (broadcastOption === BROADCAST_OPTIONS.byBundler) {
          // ZKX: record the option as unquotable instead of returning silently.
          // Leaving `feeSpeeds[identifier]` undefined makes the UI fall back to
          // a 0 amount with no speed coverage, which renders as a funded option
          // claiming "Insufficient amount" (helpers.tsx `mapFeeOptions`).
          if (!estimation.bundlerEstimation) {
            this.feeSpeeds[identifier] = []
            return
          }

          usesPaymaster = !!estimation.bundlerEstimation?.paymaster.isUsable()
          // ZKX: quote the FULL gas the EntryPoint charges, not a subset.
          // Upstream sums only `gasUsed + preVerificationGas + option.gasUsed`,
          // which omits `verificationGasLimit` and both paymaster gas limits.
          // Ambire's relayer tolerates the gap because it debits the observed
          // on-chain cost; the ZKX paymaster instead validates that the offered
          // fee covers the broadcast and rejects the userOp when it does not
          // ("The offered fee is below the cost of broadcasting this
          // transaction"), so every omitted component is a hard failure here.
          // `gasUsed` already carries the deployment/activator overhead.
          simulatedGasLimit =
            BigInt(gasUsed) +
            BigInt(estimation.bundlerEstimation.preVerificationGas) +
            BigInt(estimation.bundlerEstimation.verificationGasLimit) +
            BigInt(option.gasUsed)

          if (usesPaymaster) {
            simulatedGasLimit +=
              BigInt(estimation.bundlerEstimation.paymasterVerificationGasLimit) +
              BigInt(estimation.bundlerEstimation.paymasterPostOpGasLimit)
          }
          amountGasPrice = BigInt(increasedPrices.maxFeePerGas)
          gasPrice = BigInt(receivedPrices.maxFeePerGas)
          maxPriorityFeePerGas = BigInt(receivedPrices.maxPriorityFeePerGas)
        } else if (
          // EOA OR 7702: pays with native by itself
          broadcastOption === BROADCAST_OPTIONS.bySelf ||
          broadcastOption === BROADCAST_OPTIONS.bySelf7702
        ) {
          simulatedGasLimit = gasUsed
          gasPrice = BigInt(increasedPrices.maxFeePerGas)
          maxPriorityFeePerGas = BigInt(increasedPrices.maxPriorityFeePerGas)
          amountGasPrice = BigInt(receivedPrices.maxFeePerGas)

          this.accountOp.calls.forEach((call) => {
            if (call.to && getAddress(call.to) === SINGLETON) {
              simulatedGasLimit = getGasUsed(simulatedGasLimit)
            }
          })
        } else if (broadcastOption === BROADCAST_OPTIONS.byOtherEOA) {
          // Smart account, but EOA pays the fee
          // 7702, and it pays for the fee by itself
          simulatedGasLimit = gasUsed
          gasPrice = BigInt(increasedPrices.maxFeePerGas)
          maxPriorityFeePerGas = BigInt(increasedPrices.maxPriorityFeePerGas)
          amountGasPrice = BigInt(receivedPrices.maxFeePerGas)
        } else {
          // Relayer.
          // ZKX: add the signature-verification / execute() overhead the
          // deployless estimation omits (it runs the calls in a sender context
          // without a sig check). Upstream's relayer debits the observed on-chain
          // cost so the gap is harmless there, but the ZKX relayer simulates AND
          // broadcasts at exactly this gasLimit and rejects an under-estimate as
          // out-of-gas — leaving the tx stuck. This mirrors the byBundler branch,
          // which already adds the components upstream omits. See gas.ts.
          simulatedGasLimit = getRelayerSimulatedGasLimit(gasUsed, option.gasUsed)
          // Buffer the FEE amount's gas price (not the broadcast price — the
          // executor broadcasts at its own live price) so the reserved fee clears
          // the executor's live-gas + margin re-check on a volatile chain.
          amountGasPrice = applyRelayerFeeGasBuffer(BigInt(increasedPrices.maxFeePerGas))
          gasPrice = BigInt(increasedPrices.maxFeePerGas)
          maxPriorityFeePerGas = BigInt(increasedPrices.maxPriorityFeePerGas)
        }

        if (typeof this.customGasLimit !== 'undefined') {
          simulatedGasLimit = this.customGasLimit
        }

        amount = calculateFeeAmount({
          broadcastOption,
          simulatedGasLimit,
          gasPrice: amountGasPrice,
          nativeRatio,
          feeTokenDecimals: option.token.decimals,
          addedNative: broadcastOption === BROADCAST_OPTIONS.byBundler ? 0n : option.addedNative,
          usesPaymaster
        })

        const feeSpeed: SpeedCalc = {
          type: speed,
          simulatedGasLimit,
          amount,
          amountFormatted: formatUnits(amount, Number(option.token.decimals)),
          amountUsd: getTokenUsdAmount(option.token, amount),
          gasPrice,
          // undefined will switch the broadcast type to 0, legacy
          maxPriorityFeePerGas: maxPriorityFeePerGas > 0n ? maxPriorityFeePerGas : undefined,
          disabled: option.availableAmount < amount
        }
        if (this.feeSpeeds[identifier] === undefined) this.feeSpeeds[identifier] = []
        this.feeSpeeds[identifier].push(feeSpeed)
      }
    })
  }

  #getGasFeePayment(paidByKeyType?: Key['type']): GasFeePayment | null {
    if (!this.isInitialized) {
      this.emitError({
        level: 'major',
        message:
          'Something went wrong while setting up the gas fee payment account and token. Please try again, selecting the account and token option. If the problem persists, contact support.',
        error: new Error(
          'SignAccountOpController: The controller is not initialized while we are trying to build GasFeePayment.'
        )
      })

      return null
    }
    if (!this.#paidBy) {
      this.emitError({
        level: 'silent',
        message: '',
        error: new Error('SignAccountOpController: paying account not selected')
      })

      return null
    }

    let updatedPaidByKeyType = this.accountOp.gasFeePayment?.paidByKeyType || null

    // Update only if it's not set or it's passed as an argument
    if (paidByKeyType || !updatedPaidByKeyType) {
      const key = this.#keystore.getFeePayerKey(
        this.accountOp.accountAddr,
        this.#paidBy,
        paidByKeyType
      )

      // If paidBy is not an EOA then there will be an error here, because
      // the key of SAs is not the same as the address of the account.
      // We don't care about this here, as the validation is done during broadcast
      if (key instanceof Error) {
        updatedPaidByKeyType = null
      } else {
        updatedPaidByKeyType = key.type
      }
    }

    if (!this.feeTokenResult) {
      this.emitError({
        level: 'silent',
        message: '',
        error: new Error('SignAccountOpController: fee token not selected')
      })

      return null
    }

    // if there are no availableFeeOptions, we don't have a gasFee
    // this is normal though as there are such cases:
    // - EOA paying in native but doesn't have any native
    // so no error should pop out because of this
    if (!this.estimation.availableFeeOptions.length) {
      return null
    }

    if (!this.selectedOption) {
      this.emitError({
        level: 'silent',
        message: '',
        error: new Error('SignAccountOpController: paying option not found')
      })

      return null
    }

    // if there are no fee speeds available for the option, it means
    // the nativeRatio could not be calculated. In that case, we do not
    // emit an error here but proceed and show an explanation to the user
    // in get errors()
    // check test: Signing [Relayer]: ... priceIn | native/Ratio
    const identifier = getFeeSpeedIdentifier(this.selectedOption, this.accountOp.accountAddr)
    if (!this.feeSpeeds[identifier] || !this.feeSpeeds[identifier].length) {
      return null
    }

    const chosenSpeed = this.feeSpeeds[identifier]?.find(
      (speed) => speed.type === this.selectedFeeSpeed
    )
    if (!chosenSpeed) {
      this.emitError({
        level: 'silent',
        message: '',
        error: new Error('SignAccountOpController: fee speed not selected')
      })

      return null
    }

    return {
      paidBy: this.#paidBy,
      paidByKeyType: updatedPaidByKeyType,
      isGasTank: this.feeTokenResult.flags.onGasTank,
      inToken: this.feeTokenResult.address,
      feeTokenChainId: this.feeTokenResult.chainId,
      amount: chosenSpeed.amount,
      simulatedGasLimit: this.customGasLimit ?? chosenSpeed.simulatedGasLimit,
      gasPrice: chosenSpeed.gasPrice,
      maxPriorityFeePerGas:
        'maxPriorityFeePerGas' in chosenSpeed ? chosenSpeed.maxPriorityFeePerGas : undefined,
      isCustomGasLimit: typeof this.customGasLimit !== 'undefined',
      broadcastOption: this.baseAccount.getBroadcastOption(this.selectedOption, {
        op: this.accountOp,
        isSponsored: this.isSponsored
      })
    }
  }

  get feeToken(): string | null {
    return this.accountOp.gasFeePayment?.inToken || null
  }

  get accountKeyStoreKeys(): Key[] {
    // we take signing keys from the state as Safe account signers
    // may be different per network.
    // if the account isn't a Safe, we return the hardcoded associatedKeys
    // from the account itself in the accountState
    const state =
      this.#accounts.accountStates[this.account.addr]?.[this.#network.chainId.toString()]
    if (!state) return []
    if (this.account.safeCreation) return state.importedAccountKeys

    return this.#keystore.keys.filter((key) => state.associatedKeys.includes(key.addr))
  }

  get feePayerKeyStoreKeys(): Key[] {
    const feePayer = this.#accounts.accounts.find(
      ({ addr }) => addr === this.accountOp.gasFeePayment?.paidBy
    )

    if (!feePayer) return []

    return this.#keystore.getAccountKeys(feePayer)
  }

  // eslint-disable-next-line class-methods-use-this
  get speedOptions() {
    return Object.values(FeeSpeed) as string[]
  }

  get gasSavedUSD(): number | null {
    if (!this.selectedOption?.token.flags.onGasTank) return null

    const identifier = getFeeSpeedIdentifier(this.selectedOption, this.accountOp.accountAddr)
    const selectedFeeSpeedData = this.feeSpeeds[identifier]?.find(
      (speed) => speed.type === this.selectedFeeSpeed
    )
    const gasPrice = selectedFeeSpeedData?.gasPrice
    if (!gasPrice) return null

    // get the native token from the portfolio to calculate prices
    const native = this.#portfolio
      .getAccountPortfolioState(this.accountOp.accountAddr)
      [
        this.accountOp.chainId.toString()
      ]?.result?.tokens.find((token) => token.address === ZeroAddress)
    if (!native) return null
    const nativePrice = native.priceIn.find((price) => price.baseCurrency === 'usd')?.price
    if (!nativePrice) return null

    // 4337 gasUsed is set to 0 in the estimation as we rely
    // on the bundler for the estimation entirely => use hardcode value
    const gasUsedSelectedOption =
      this.selectedOption.gasUsed > 0n ? this.selectedOption.gasUsed : GAS_TANK_TRANSFER_GAS_USED
    const isNativeSelected = this.selectedOption.token.address === ZeroAddress
    const gasUsedNative =
      this.estimation.availableFeeOptions.find(
        (option) => option.token.address === ZeroAddress && !option.token.flags.onGasTank
      )?.gasUsed || SA_NATIVE_TRANSFER_GAS_USED
    const gasUsedERC20 =
      this.estimation.availableFeeOptions.find(
        (option) => option.token.address !== ZeroAddress && !option.token.flags.onGasTank
      )?.gasUsed || SA_ERC20_TRANSFER_GAS_USED

    const gasUsedWithoutGasTank = isNativeSelected ? gasUsedNative : gasUsedERC20
    const gasSavedInNative = formatEther((gasUsedWithoutGasTank - gasUsedSelectedOption) * gasPrice)

    return Number(gasSavedInNative) * nativePrice
  }

  #emitSigningErrorAndResetToReadyToSign({
    message,
    sendCrashReport,
    accountState
  }: {
    message: string
    sendCrashReport?: boolean
    accountState?: AccountOnchainState
  }) {
    this.emitError({ level: 'major', message, error: new Error(message), sendCrashReport })
    this.status = { type: SigningStatus.ReadyToSign }

    this.emitUpdate()
  }

  #addFeePayment() {
    // In case of gas tank token fee payment, we need to include one more call to account op
    const abiCoder = new AbiCoder()

    if (this.isSponsored) {
      this.#updateAccountOp({
        feeCall: {
          to: FEE_COLLECTOR,
          value: 0n,
          data: abiCoder.encode(
            ['string', 'uint256', 'string', 'uint256'],
            ['gasTank', 0n, 'USDC', this.accountOp.chainId]
          )
        }
      })

      return
    }

    if (this.accountOp.gasFeePayment!.isGasTank) {
      this.#updateAccountOp({
        feeCall: {
          to: FEE_COLLECTOR,
          value: 0n,
          data: abiCoder.encode(
            ['string', 'uint256', 'string', 'uint256'],
            [
              'gasTank',
              this.accountOp.gasFeePayment!.amount,
              this.feeTokenResult?.symbol,
              this.feeTokenResult!.chainId
            ]
          )
        }
      })

      return
    }

    if (this.accountOp.gasFeePayment!.inToken === ZeroAddress) {
      // native payment
      this.#updateAccountOp({
        feeCall: {
          to: FEE_COLLECTOR,
          value: this.accountOp.gasFeePayment!.amount,
          data: '0x'
        }
      })
    } else {
      // token payment
      const ERC20Interface = new Interface(ERC20.abi)
      this.#updateAccountOp({
        feeCall: {
          to: this.accountOp.gasFeePayment!.inToken,
          value: 0n,
          data: ERC20Interface.encodeFunctionData('transfer', [
            FEE_COLLECTOR,
            this.accountOp.gasFeePayment!.amount
          ])
        }
      })
    }
  }

  async #getInitialUserOp(
    shouldReestimate: boolean,
    eip7702Auth?: EIP7702Auth,
    counter: number = 0
  ): Promise<UserOperation> {
    const gasFeePayment = this.accountOp.gasFeePayment!
    let erc4337Estimation = this.estimation.estimation!.bundlerEstimation as Erc4337GasLimits
    const accountState = await this.#accounts.getOrFetchAccountOnChainState(
      this.accountOp.accountAddr,
      this.accountOp.chainId
    )

    if (!accountState) {
      throw new EmittableError({
        message: `Missing mandatory transaction data (account state). ${RETRY_TO_INIT_ACCOUNT_OP_MSG}`,
        level: 'major'
      })
    }
    if (!this.gasPrices) {
      throw new EmittableError({
        message: `Missing mandatory transaction data (gas prices). ${RETRY_TO_INIT_ACCOUNT_OP_MSG}`,
        level: 'major'
      })
    }

    if (shouldReestimate) {
      const latestGasPricesResponse = await fetchBundlerGasPrice(
        this.baseAccount,
        this.#network,
        this.bundlerSwitcher
      )
      const latestGasPrices =
        latestGasPricesResponse instanceof Error ? this.gasPrices : latestGasPricesResponse
      const newEstimate = await bundlerEstimate(
        this.baseAccount,
        accountState,
        this.accountOp,
        this.#network,
        [this.selectedOption!.token],
        this.provider,
        latestGasPrices,
        this.bundlerSwitcher,
        eip7702Auth
      )

      if (newEstimate instanceof Error) {
        if (counter === 0) {
          await this.#accounts
            .updateAccountState(this.accountOp.accountAddr, 'pending', [this.accountOp.chainId])
            // eslint-disable-next-line no-console
            .catch((e) => console.error(e))
          return this.#getInitialUserOp(true, eip7702Auth, 1)
        }

        throw newEstimate
      }

      // set the new estimation value
      erc4337Estimation = newEstimate as Erc4337GasLimits
      this.gasPrices = erc4337Estimation.gasPrice
      gasFeePayment.gasPrice = BigInt(this.gasPrices[this.selectedFeeSpeed!].maxFeePerGas)
      gasFeePayment.maxPriorityFeePerGas = BigInt(
        this.gasPrices[this.selectedFeeSpeed!].maxPriorityFeePerGas
      )

      // ZKX: re-quote the fee from the fresh limits. This re-estimation is the
      // first one that sees the real userOp — most importantly the EIP-7702
      // authorization, whose calldata pushes `preVerificationGas` well above
      // the quote the user was shown (measured on Base: 56872 -> 84359). The
      // Gas Tank commitment is built from `gasFeePayment.amount`, so leaving it
      // at the pre-auth value offers less than the broadcast costs and the ZKX
      // paymaster rejects the op. Only ever raise it: never silently quote the
      // user a smaller fee than the one they approved.
      this.estimation.estimation!.bundlerEstimation = erc4337Estimation
      this.#updateFeeSpeeds()
      const identifier = getFeeSpeedIdentifier(this.selectedOption!, this.accountOp.accountAddr)
      const reQuoted = this.feeSpeeds[identifier]?.find(
        (speed) => speed.type === this.selectedFeeSpeed
      )

      if (reQuoted && reQuoted.amount > gasFeePayment.amount) {
        // ZKX: the raise lands AFTER the user approved the fee, so it can grow
        // past what the selected fee token actually holds — every balance check
        // (`#getIsFeeOptionDisabled`, the `availableAmount < amount` error in
        // `errors`) ran against the OLD, smaller quote. Broadcasting anyway
        // signs a userOp whose fee call is certain to revert
        // ("Dai/insufficient-balance"), and because the op is atomic it takes
        // the user's actual calls down with it while the outer txn still mines
        // with status 0x1 — the user pays the gas and sees a "successful" tx
        // that did nothing. Refuse here instead and send them back to the fee
        // selection to pick a token that covers the new quote.
        if (
          this.selectedOption &&
          !canFeeOptionCoverAmount(this.selectedOption, this.accountOp, reQuoted.amount)
        ) {
          const { symbol, decimals } = this.selectedOption.token
          throw new EmittableError({
            level: 'major',
            message: `The transaction fee rose to ${formatUnits(
              reQuoted.amount,
              Number(decimals)
            )} ${symbol} while preparing the broadcast, which is more than the ${formatUnits(
              this.selectedOption.availableAmount,
              Number(decimals)
            )} ${symbol} this account holds. Please pay the fee with another token and try again.`,
            error: new Error(
              `Re-quoted 4337 fee ${reQuoted.amount} exceeds the available ${this.selectedOption.availableAmount} of ${symbol} (chainId ${this.accountOp.chainId})`
            )
          })
        }

        gasFeePayment.amount = reQuoted.amount
        if (!gasFeePayment.isCustomGasLimit)
          gasFeePayment.simulatedGasLimit = reQuoted.simulatedGasLimit

        // rebuild the fee call so the on-chain commitment carries the new amount
        if (this.accountOp.feeCall) this.#addFeePayment()
      }
    }

    const userOperation = getUserOperation({
      account: this.account,
      accountState,
      accountOp: this.accountOp,
      bundler: this.bundlerSwitcher.getBundler().getName(),
      entryPointSig: this.accountOp.meta?.entryPointAuthorization,
      eip7702Auth,
      hasPendingUserOp: !!(this.#activity.broadcastedButNotConfirmed[this.account.addr] || []).find(
        (accOp) =>
          accOp.accountAddr === this.account.addr &&
          accOp.chainId === this.#network.chainId &&
          !!accOp.asUserOperation
      )
    })

    userOperation.preVerificationGas = erc4337Estimation.preVerificationGas
    userOperation.callGasLimit = toBeHex(
      BigInt(erc4337Estimation.callGasLimit) + this.selectedOption!.gasUsed
    )
    userOperation.verificationGasLimit = erc4337Estimation.verificationGasLimit
    userOperation.maxFeePerGas = toBeHex(gasFeePayment.gasPrice)
    userOperation.maxPriorityFeePerGas = toBeHex(gasFeePayment.maxPriorityFeePerGas!)

    const ambireAccount = new Interface(AmbireAccount.abi)
    userOperation.callData = ambireAccount.encodeFunctionData('executeBySender', [
      getSignableCalls(this.accountOp)
    ])

    return userOperation
  }

  /**
   * ZKX: turn a paymaster rejection into something the user can act on.
   * `isFeeBelowBroadcastCost` is a STRUCTURAL shortfall (see helper.ts) — the
   * fee quote cannot cover the broadcast, and retrying reproduces it exactly.
   * Say so and point at the way out (another fee token) instead of echoing the
   * backend wording, which reads like a transient hiccup.
   */
  // eslint-disable-next-line class-methods-use-this
  #getPaymasterRejectionMessage(backendMessage: string): string {
    if (!isFeeBelowBroadcastCost(backendMessage)) return backendMessage

    return 'The fee offered for this transaction does not cover its broadcast cost, so it was rejected. Retrying will not help — please pay the fee with another token.'
  }

  /**
   * ZKX: prove to the relayer that we hold a key of the account BEFORE it
   * reserves the account's gas-tank balance for the sponsorship. Without it
   * anyone can POST a funded stranger as `userOperation.sender` and pin their
   * balance and daily-cap headroom until the sweeper reclaims it.
   *
   * The authorization is session-scoped and cached (see
   * libs/paymaster/sponsorshipAuthorization.ts), so this costs a hardware
   * wallet at most one extra confirmation per account/chain per day instead of
   * one per transaction. Only the relayer-signed (`isAmbire`) paymaster route
   * consumes it; an ERC-7677 dApp sponsorship never asks for it.
   */
  #getSponsorshipAuthorizer(signer: KeystoreSignerInterface): SponsorshipAuthorizer {
    return async (): Promise<SponsorshipAuthorization> => {
      const account = this.accountOp.accountAddr
      const key = this.accountOp.signingKeyAddr!
      const { chainId } = this.#network

      const cached = sponsorshipSessions.get(chainId, account, key)
      if (cached) return cached

      const expiresAt = Math.floor(Date.now() / 1000) + SPONSORSHIP_SESSION_TTL_SECONDS
      const typedData = getSponsorshipAuthorizationTypedData(chainId, account, key, expiresAt)
      const signature = await this.#withHardwareWalletSigningRequest(
        getEIP712SigningRequest(typedData),
        () => signer.signTypedData(typedData)
      )

      const authorization: SponsorshipAuthorization = { account, key, expiresAt, signature }
      sponsorshipSessions.set(chainId, authorization)
      return authorization
    }
  }

  async #getPaymasterUserOp(
    originalUserOp: UserOperation,
    paymaster: AbstractPaymaster,
    signer: KeystoreSignerInterface,
    eip7702Auth?: EIP7702Auth,
    counter = 0
  ): Promise<{
    required: boolean
    success?: boolean
    userOp?: UserOperation
    errorResponse?: PaymasterErrorReponse
  }> {
    if (!paymaster.isUsable()) return { required: false }

    const localOp = { ...originalUserOp }

    // set the paymaster properties
    const erc4337Estimation = this.estimation.estimation!.bundlerEstimation as Erc4337GasLimits
    localOp.paymasterVerificationGasLimit = erc4337Estimation.paymasterVerificationGasLimit
    localOp.paymasterPostOpGasLimit = erc4337Estimation.paymasterPostOpGasLimit

    // some bundlers (etherspot) don't return values for paymaster gas limits
    // so we need to set them manually
    // other (gelato) may return below the min
    if (paymaster.isEstimateBelowMin(localOp)) {
      const estimationData = paymaster.getEstimationData()!
      localOp.paymasterVerificationGasLimit = estimationData.paymasterVerificationGasLimit
      localOp.paymasterPostOpGasLimit = estimationData.paymasterPostOpGasLimit
    }

    // persist the paymaster properties from the pm_stubData request if any
    if (paymaster.isSponsored() && paymaster.sponsorDataEstimation) {
      if (paymaster.sponsorDataEstimation.paymasterVerificationGasLimit) {
        localOp.paymasterVerificationGasLimit =
          paymaster.sponsorDataEstimation.paymasterVerificationGasLimit
      }
      if (paymaster.sponsorDataEstimation.paymasterPostOpGasLimit) {
        localOp.paymasterPostOpGasLimit = paymaster.sponsorDataEstimation.paymasterPostOpGasLimit
      }
    }
    const response = await paymaster.call(
      this.account,
      this.accountOp,
      localOp,
      this.#network,
      // the userOp itself is signed further down the flow; this only
      // authorizes the sponsorship request
      paymaster.isAmbire() ? this.#getSponsorshipAuthorizer(signer) : undefined
    )

    if (response.success) {
      const paymasterData = response as PaymasterSuccessReponse
      localOp.paymaster = paymasterData.paymaster
      localOp.paymasterData = paymasterData.paymasterData
      return {
        userOp: localOp,
        required: true,
        success: true
      }
    }

    const errorResponse = response as PaymasterErrorReponse
    if (errorResponse.message.indexOf('invalid account nonce') !== -1) {
      // continue on error as this is an attempt for an UX improvement
      await this.#accounts
        .updateAccountState(this.accountOp.accountAddr, 'pending', [this.accountOp.chainId])
        // eslint-disable-next-line no-console
        .catch((e) => console.error(e))
    }

    if (paymaster.isAmbire() && counter === 0) {
      const reestimatedUserOp = await this.#getInitialUserOp(true, eip7702Auth)
      return this.#getPaymasterUserOp(
        reestimatedUserOp,
        paymaster,
        signer,
        eip7702Auth,
        counter + 1
      )
    }

    return {
      required: true,
      success: false,
      errorResponse
    }
  }

  async sign() {
    if (!this.readyToSign) {
      const message = `Unable to sign the transaction. During the preparation step, the necessary transaction data was not received. ${RETRY_TO_INIT_ACCOUNT_OP_MSG}`
      return this.#emitSigningErrorAndResetToReadyToSign({ message })
    }

    // when signing begings, we stop immediatelly state updates on the controller
    // by changing the status to InProgress. Check update() for more info
    this.status = { type: SigningStatus.InProgress }

    this.#hwCleanup()

    if (!this.accountOp.signingKeyAddr || !this.accountOp.signingKeyType) {
      const message = `Unable to sign the transaction. During the preparation step, required signing key information was found missing. ${RETRY_TO_INIT_ACCOUNT_OP_MSG}`
      return this.#emitSigningErrorAndResetToReadyToSign({ message })
    }

    if (!this.accountOp.gasFeePayment || !this.selectedOption) {
      const message = `Unable to sign the transaction. During the preparation step, required information about paying the gas fee was found missing. ${RETRY_TO_INIT_ACCOUNT_OP_MSG}`
      return this.#emitSigningErrorAndResetToReadyToSign({ message })
    }

    if (!this.estimation.estimation) {
      const message = `Unable to sign the transaction. During the preparation step, required account key information was found missing. ${RETRY_TO_INIT_ACCOUNT_OP_MSG}`
      return this.#emitSigningErrorAndResetToReadyToSign({ message })
    }

    const estimation = this.estimation.estimation as FullEstimationSummary
    const broadcastOption = this.accountOp.gasFeePayment.broadcastOption
    const isUsingPaymaster = !!estimation.bundlerEstimation?.paymaster.isUsable()
    const shouldSignDeployAuth = this.baseAccount.shouldSignDeployAuth(broadcastOption)

    // tell the FE where we are
    if (shouldSignDeployAuth) {
      this.shouldSignAuth = {
        type: 'V2Deploy',
        text: 'Step 1/2 preparing account'
      }
    }

    // in Safe, you won't have to choose the signers, and they could be multiple
    // we need to take the signers from the account state
    // check which we have in the extension (they will be in keystore)
    // decide what to do from that point onwards

    const isExternalSignerInvolved =
      this.accountOp.gasFeePayment.paidByKeyType !== 'internal' ||
      this.accountOp.signingKeyType !== 'internal'
    const isImmediatelyWaitingForPaymaster =
      broadcastOption === BROADCAST_OPTIONS.byBundler &&
      isUsingPaymaster &&
      !shouldSignDeployAuth &&
      !this.baseAccount.shouldSignAuthorization(BROADCAST_OPTIONS.byBundler)

    if (isImmediatelyWaitingForPaymaster) this.status = { type: SigningStatus.WaitingForPaymaster }

    // we update the FE with the changed status (in progress) only after the checks
    // above confirm everything is okay to prevent two different state updates
    this.emitUpdate()

    // just in-case: before signing begins, we delete the feeCall;
    // if there's a need for it, it will be added later on in the code.
    // We need this precaution because this could happen:
    // - try to broadcast with the relayer
    // - the feel call gets added
    // - the relayer broadcast fails
    // - the user does another broadcast, this time with EOA pays for SA
    // - the fee call stays, causing a low gas limit revert
    delete this.#accountOp.feeCall

    // delete the activatorCall as a precaution that it won't be added twice
    delete this.#accountOp.activatorCall

    // @EntryPoint activation for SA
    if (this.baseAccount.shouldIncludeActivatorCall(this.accountOp.gasFeePayment.paidBy)) {
      this.#accountOp.activatorCall = getActivatorCall(this.accountOp.accountAddr)
    }

    const accountState = await this.#accounts.getOrFetchAccountOnChainState(
      this.accountOp.accountAddr,
      this.accountOp.chainId
    )

    if (!accountState) {
      const message = `Unable to sign the transaction. During the preparation step, required transaction information was found missing (account state). ${RETRY_TO_INIT_ACCOUNT_OP_MSG}`
      return this.#emitSigningErrorAndResetToReadyToSign({ message, accountState })
    }

    try {
      if (
        this.account.safeCreation &&
        this.#accountOp.signed &&
        this.#accountOp.signed.length >= this.threshold
      ) {
        // all's good, proceed to broadcast
      } else if (this.account.safeCreation) {
        // if the Safe txn is not already signed, fetch the latest nonce
        // as we don't have a mechanism for fixing nonces for Safe accounts
        // during the estimation phase itself
        if (!this.accountOp.safeTx) {
          const latestNonce = await getNonce(this.accountOp.accountAddr, this.provider).catch(
            (e) => {
              console.log('failed to retrieve the latest nonce for Safe')
              console.log(e)
              return null
            }
          )
          if (latestNonce) {
            this.#updateAccountOp({
              nonce: latestNonce
            })
          }
        }

        const prevSignedSigs = getSigs(this.accountOp.signature)
        const nowSignedSigs: Hex[] = []

        const safeSigner = await this.#keystore.getSigner(
          this.accountOp.signingKeyAddr,
          this.accountOp.signingKeyType
        )
        if (safeSigner.init)
          safeSigner.init(this.#externalSignerControllers[this.accountOp.signingKeyType])

        const safeTxn = getSafeTxn(this.accountOp, accountState)
        const typedData = (this.baseAccount as Safe).getTxnTypedData(safeTxn)
        const safeTxnHash = getSafeTxnHash(typedData)
        const signature = (await this.#withHardwareWalletSigningRequest(
          getEIP712SigningRequest({ ...typedData, safeTxHash: safeTxnHash }),
          () => safeSigner.signTypedData(typedData)
        )) as Hex
        nowSignedSigs.push(signature)

        // all the signers that have signed
        const allSigners = this.accountOp.signed
          ? this.accountOp.signed.concat([this.accountOp.signingKeyAddr])
          : [this.accountOp.signingKeyAddr]

        const isQuickBroadcast = this.threshold === 1 && this.accountKeyStoreKeys.length === 1
        if (!isQuickBroadcast) {
          if (!prevSignedSigs.length) {
            // propose the txn to Safe Global upon first entry
            await propose(
              safeTxn,
              this.accountOp.chainId,
              this.account.addr as Hex,
              this.#accountOp.signingKeyAddr as Hex,
              signature,
              safeTxnHash
            ).catch((e) => {
              this.hasSafeApiFailed = true
              console.log('Safe API: failed to propose txn', e)
            })
          } else {
            // add extra confirmations
            await confirm(this.accountOp.chainId, signature, safeTxnHash).catch((e) => {
              this.hasSafeApiFailed = true
              console.log('Safe API: faield to confirm txn', e)
            })
          }

          this.status = { type: SigningStatus.Queued }
        }

        this.#updateAccountOp({
          signature: sortSigs(
            prevSignedSigs.concat(nowSignedSigs),
            safeTxnHash,
            this.accountOp.safeTx?.confirmations
          ),
          signed: allSigners,
          txnId: safeTxnHash
        })
      } else if (
        broadcastOption === BROADCAST_OPTIONS.bySelf ||
        broadcastOption === BROADCAST_OPTIONS.bySelf7702
      ) {
        // plain EOA
        // rawTxn, No SA signatures
        // or 7702, calling executeBySender(). No SA signatures
        this.#updateAccountOp({ signature: '0x' })
      } else if (broadcastOption === BROADCAST_OPTIONS.byOtherEOA) {
        // SA, EOA pays fee. execute() needs a signature
        if (!this.isSpeedUpTransaction) {
          // fetch the nonce if needed
          const nonce = await this.baseAccount.getBroadcastNonce(
            this.#activity,
            this.accountOp,
            this.provider
          )
          if (nonce !== this.accountOp.nonce) this.#updateAccountOp({ nonce })

          const signer = await this.#getDefaultSigner()
          this.#updateAccountOp({
            signature: await this.#withHardwareWalletSigningRequest(
              getExecuteSigningRequest({
                accountOp: this.accountOp,
                accountState,
                network: this.#network
              }),
              () => getExecuteSignature(this.#network, this.accountOp, accountState, signer)
            )
          })
        }
      } else if (broadcastOption === BROADCAST_OPTIONS.delegation) {
        // a delegation request has been made
        if (!this.accountOp.meta) {
          this.#updateAccountOp({ meta: {} })
        }

        const contract =
          this.accountOp.meta?.setDelegation || this.accountOp.calls.length > 1
            ? getContractImplementation(this.#network.chainId, this.accountKeyStoreKeys)
            : (ZeroAddress as Hex)
        if (this.accountOp.meta) {
          if (isExternalSignerInvolved)
            this.shouldSignAuth = { type: '7702', text: 'Step 1/2 preparing account' }

          const signer = await this.#getDefaultSigner()
          const authorization = {
            chainId: this.#network.chainId,
            contract,
            // because we're broadcasting by ourselves, we need to add 1 to the nonce
            // as the sender nonce (the curr acc) gets incremented before the
            // authrorization validation
            nonce: accountState.eoaNonce! + 1n
          }
          this.accountOp.meta.delegation = get7702Sig(
            this.#network.chainId,
            authorization.nonce,
            contract,
            await this.#withHardwareWalletSigningRequest(
              get7702AuthorizationSigningRequest(authorization),
              () => signer.sign7702(authorization)
            )
          )
          if (isExternalSignerInvolved)
            this.shouldSignAuth = { type: '7702', text: 'Step 2/2 signing transaction' }
        }
        this.#updateAccountOp({ signature: '0x' })
      } else if (broadcastOption === BROADCAST_OPTIONS.byBundler) {
        const signer = await this.#getDefaultSigner()
        const erc4337Estimation = estimation.bundlerEstimation as Erc4337GasLimits

        const paymaster = erc4337Estimation.paymaster
        if (paymaster.shouldIncludePayment()) this.#addFeePayment()

        // fix three problems:
        // 1) when we do eip7702Auth, initial estimation is not enough
        // 2) we estimate with the gas tank but if the user chooses
        // native, it could result in low gas limit => txn price too low.
        // In both cases, we re-estimate before broadcast
        // 3) some bundlers require a re-estimate before broadcast
        let shouldReestimate =
          (!!erc4337Estimation.feeCallType &&
            paymaster.getFeeCallType([this.selectedOption.token]) !==
              erc4337Estimation.feeCallType) ||
          this.bundlerSwitcher.getBundler().shouldReestimateBeforeBroadcast(this.#network)

        // sign the 7702 authorization if needed
        let eip7702Auth
        if (this.baseAccount.shouldSignAuthorization(BROADCAST_OPTIONS.byBundler)) {
          if (isExternalSignerInvolved)
            this.shouldSignAuth = { type: '7702', text: 'Step 1/2 preparing account' }
          const contract = getContractImplementation(
            this.#network.chainId,
            this.accountKeyStoreKeys
          )
          const authorization = {
            chainId: this.#network.chainId,
            contract,
            nonce: accountState.nonce
          }
          eip7702Auth = get7702Sig(
            this.#network.chainId,
            accountState.nonce,
            contract,
            await this.#withHardwareWalletSigningRequest(
              get7702AuthorizationSigningRequest(authorization),
              () => signer.sign7702(authorization)
            )
          )
          if (isExternalSignerInvolved)
            this.shouldSignAuth = { type: '7702', text: 'Step 2/2 signing transaction' }
          if (isUsingPaymaster) {
            this.status = { type: SigningStatus.WaitingForPaymaster }
            this.emitUpdate()
          }
          shouldReestimate = true
        }

        if (shouldSignDeployAuth) {
          const epActivatorTypedData = await getEntryPointAuthorization(
            this.account.addr,
            this.#network.chainId,
            accountState.nonce
          )
          const epSignature = await this.#withHardwareWalletSigningRequest(
            getEIP712SigningRequest(epActivatorTypedData),
            () =>
              getEIP712Signature(
                epActivatorTypedData,
                this.account,
                accountState,
                signer,
                this.#network
              )
          )
          if (!this.accountOp.meta) {
            this.#updateAccountOp({ meta: {} })
          }
          if (this.accountOp.meta)
            this.accountOp.meta.entryPointAuthorization = adjustEntryPointAuthorization(
              epSignature.signature
            )

          // after signing is complete, go to paymaster mode
          if (isUsingPaymaster) {
            this.shouldSignAuth = {
              type: 'V2Deploy',
              text: 'Step 2/2 signing transaction'
            }
            this.status = { type: SigningStatus.WaitingForPaymaster }
            this.emitUpdate()
          }

          shouldReestimate = true
        }

        const initialUserOp = await this.#getInitialUserOp(shouldReestimate, eip7702Auth)
        const paymasterInfo = await this.#getPaymasterUserOp(
          initialUserOp,
          paymaster,
          signer,
          eip7702Auth
        )
        if (paymasterInfo.required) {
          if (paymasterInfo.success) {
            this.accountOp.gasFeePayment.isSponsored = paymaster.isSponsored()
            this.status = { type: SigningStatus.InProgress }
            this.emitUpdate()
          } else {
            const errorResponse = paymasterInfo.errorResponse as PaymasterErrorReponse
            // A transient underpricing (the network gas price moved under us) is
            // worth retrying: refresh the gas price first so the next attempt
            // quotes the current one. Mirrors upstream's soft-retry path.
            const isGasFeeUnderpriced = isUnderpriced(errorResponse.message)
            if (isGasFeeUnderpriced && !this.hasCustomGasPrices) {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              this.#silentGasPriceUpdate()
            }

            this.emitError({
              level: 'major',
              message: isGasFeeUnderpriced
                ? 'Transaction fees changed. Please try again'
                : this.#getPaymasterRejectionMessage(errorResponse.message),
              error: errorResponse.error
            })
            this.status = { type: SigningStatus.ReadyToSign }
            this.emitUpdate()
            this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true })
            return
          }
        }

        // query the application state from memory to understand if the user
        // hasn't actually rejected the request while waiting for the
        // paymaster to respond
        if (this.#stopRefetching) return

        const userOperation = paymasterInfo.required ? paymasterInfo.userOp! : initialUserOp
        const isHotEOA = accountState.isEOA && this.accountOp.signingKeyType === 'internal'
        if (!isHotEOA) {
          const typedData = getTypedData(
            this.#network.chainId,
            this.accountOp.accountAddr,
            getUserOpHash(userOperation, this.#network.chainId)
          )
          const signature = wrapStandard(
            await this.#withHardwareWalletSigningRequest(getEIP712SigningRequest(typedData), () =>
              signer.signTypedData(typedData)
            )
          )
          userOperation.signature = signature
          this.#updateAccountOp({ signature, asUserOperation: userOperation })
        } else if (this.delegatedContract?.toLowerCase() === EIP_7702_AMBIRE_LEGACY.toLowerCase()) {
          // The account is delegated to upstream Ambire's post-Feb-2025
          // AmbireAccount7702 (an older ZKX build's target — see
          // EIP_7702_AMBIRE_LEGACY). That contract hashes userOps via
          // Eip712HashBuilder.getUserOp712Hash, so it only accepts upstream's
          // Ambire4337AccountOp struct wrapped Unprotected. The scheme is a
          // property of the DEPLOYED implementation, not of the wallet build,
          // so it must be selected from `delegatedContract` — signing these
          // with the Standard wrapper below fails on-chain with AA24.
          const typedData = get7702UserOpTypedData(
            this.#network.chainId,
            getSignableCalls(this.accountOp),
            getPackedUserOp(userOperation),
            getUserOpHash(userOperation, this.#network.chainId)
          )
          const signature = wrapUnprotected(
            await this.#withHardwareWalletSigningRequest(getEIP712SigningRequest(typedData), () =>
              signer.signTypedData(typedData)
            )
          )
          userOperation.signature = signature
          this.#updateAccountOp({ signature, asUserOperation: userOperation })
        } else {
          // ZKX: upstream signs hot-EOA 7702 userOps as the Ambire4337AccountOp
          // EIP-712 struct wrapped Unprotected (the branch right above), which
          // only validates on Ambire's post-Feb-2025 AmbireAccount. ZKX's
          // deployed 7702 implementation (EIP_7702_AMBIRE_ACCOUNT = 0xDd3bA5ED…)
          // is the pre-upgrade contract: validateUserOp recovers over the raw
          // userOpHash, so the upstream scheme fails there with AA24. Sign the
          // Standard-mode AmbireOperation wrapper instead — the same scheme the
          // !isHotEOA branch above uses — which that contract verifies
          // on-chain. Do NOT make this the unconditional branch unless the
          // deployed 7702 implementation is upgraded in lockstep.
          const typedData = getTypedData(
            this.#network.chainId,
            this.accountOp.accountAddr,
            getUserOpHash(userOperation, this.#network.chainId)
          )
          const signature = wrapStandard(
            await this.#withHardwareWalletSigningRequest(getEIP712SigningRequest(typedData), () =>
              signer.signTypedData(typedData)
            )
          )
          userOperation.signature = signature
          this.#updateAccountOp({ signature, asUserOperation: userOperation })
        }
      } else {
        const signer = await this.#getDefaultSigner()

        // Relayer
        this.#addFeePayment()

        // fetch the nonce if needed
        const nonce = await this.baseAccount.getBroadcastNonce(
          this.#activity,
          this.accountOp,
          this.provider
        )
        if (nonce !== this.accountOp.nonce) this.#updateAccountOp({ nonce })

        this.#updateAccountOp({
          signature: await this.#withHardwareWalletSigningRequest(
            getExecuteSigningRequest({
              accountOp: this.accountOp,
              accountState,
              network: this.#network
            }),
            () => getExecuteSignature(this.#network, this.accountOp, accountState, signer)
          )
        })
      }

      if (!this.status || this.status.type !== SigningStatus.Queued)
        this.status = { type: SigningStatus.Done }

      this.emitUpdate()
    } catch (error: any) {
      const { message } = getHumanReadableBroadcastError(error)

      this.#emitSigningErrorAndResetToReadyToSign({
        message,
        sendCrashReport: error?.sendCrashReport,
        accountState
      })
    }
  }

  /**
   * There are 4 ways to broadcast an AccountOp:
   *   1. For EOAs, there is only one way to do that. After
   *   signing the transaction, the serialized signed transaction object gets
   *   send to the network.
   *   2. For smart accounts, when EOA pays the fee. Two signatures are needed
   *   for this. The first one is the signature of the AccountOp itself. The
   *   second one is the signature of the transaction that will be executed
   *   by the smart account.
   *   3. For smart accounts that broadcast the ERC-4337 way.
   *   4. for smart accounts, when the Relayer does the broadcast.
   *
   */
  /**
   * The gasLimit sent to the relayer. Large estimates are re-measured with
   * eth_estimateGas on the signed execute() call — see
   * RELAYER_GAS_LIMIT_REMEASURE_THRESHOLD. Only ever LOWERS the limit, and falls
   * back to the simulated one on any failure (revert, timeout, RPC error), so
   * the worst case is the previous behaviour.
   */
  async #getRelayerBroadcastGasLimit(accountOp: AccountOp): Promise<bigint> {
    const simulatedGasLimit = accountOp.gasFeePayment!.simulatedGasLimit
    // A user-set custom limit is a deliberate choice — don't second-guess it.
    if (typeof this.customGasLimit !== 'undefined') return simulatedGasLimit
    if (simulatedGasLimit <= RELAYER_GAS_LIMIT_REMEASURE_THRESHOLD) return simulatedGasLimit
    if (!accountOp.signature) return simulatedGasLimit

    let timeout: ReturnType<typeof setTimeout> | undefined
    try {
      const measure = async (): Promise<bigint | null> => {
        // An undeployed account is broadcast as deployAndExecute() on the
        // factory; estimating execute() against its empty address would measure
        // a plain call and badly under-shoot. Only re-measure deployed code.
        const code = await this.provider.getCode(accountOp.accountAddr)
        if (!code || code === '0x') return null

        const data = new Interface(AmbireAccount.abi).encodeFunctionData('execute', [
          getSignableCalls(accountOp),
          accountOp.signature
        ])
        return this.provider.estimateGas({ to: accountOp.accountAddr, data })
      }
      const measured = await Promise.race([
        measure(),
        new Promise<never>((_, reject) => {
          timeout = setTimeout(
            () => reject(new Error('eth_estimateGas timed out')),
            RELAYER_GAS_LIMIT_REMEASURE_TIMEOUT_MS
          )
        })
      ])
      if (measured === null) return simulatedGasLimit

      const buffered = (measured * (10000n + RELAYER_REMEASURED_GAS_BUFFER_BPS)) / 10000n

      return buffered < simulatedGasLimit ? buffered : simulatedGasLimit
    } catch (e: any) {
      console.warn(
        '[SignAccountOp] relayer gasLimit re-measure failed, using the simulated limit:',
        e?.message || e
      )
      return simulatedGasLimit
    } finally {
      clearTimeout(timeout)
    }
  }

  async #broadcast() {
    if (this.status?.type !== SigningStatus.Done) {
      this.throwBroadcastAccountOp({
        message: 'Pending broadcast. Please try again in a bit.'
      })
      return
    }
    const accountOp = this.accountOp
    const estimation = this.estimation.estimation
    const requestId = this.fromRequestId
    const bundlerSwitcher = this.bundlerSwitcher
    const contactSupportPrompt = 'Please try again or contact support if the problem persists.'

    if (
      !accountOp ||
      !estimation ||
      !requestId ||
      !accountOp.signingKeyAddr ||
      !accountOp.signingKeyType ||
      !accountOp.signature ||
      !bundlerSwitcher ||
      !accountOp.gasFeePayment
    ) {
      const message = `Missing mandatory transaction details. ${contactSupportPrompt}`
      return this.throwBroadcastAccountOp({ message })
    }

    const account = this.#accounts.accounts.find((acc) => acc.addr === accountOp.accountAddr)

    if (!this.provider) {
      const networkName = this.#network?.name || `network with id ${accountOp.chainId}`
      const message = `Provider for ${networkName} not found. ${contactSupportPrompt}`
      return this.throwBroadcastAccountOp({ message })
    }

    if (!account) {
      const addr = shortenAddress(accountOp.accountAddr, 13)
      const message = `Account with address ${addr} not found. ${contactSupportPrompt}`
      return this.throwBroadcastAccountOp({ message })
    }

    if (!this.#network) {
      const message = `Network with id ${accountOp.chainId} not found. ${contactSupportPrompt}`
      return this.throwBroadcastAccountOp({ message })
    }

    this.broadcastStatus = 'LOADING'
    await this.forceEmitUpdate()

    const accountState = await this.#accounts.getOrFetchAccountOnChainState(
      accountOp.accountAddr,
      accountOp.chainId
    )
    if (!accountState) {
      const message = `Missing mandatory transaction details (account state). ${contactSupportPrompt}`

      return this.throwBroadcastAccountOp({ message, accountState })
    }
    let transactionRes: {
      txnId?: string
      nonce: number
      identifiedBy: AccountOpIdentifiedBy
    } | null = null

    // broadcasting by EOA is quite the same:
    // 1) build a rawTxn 2) sign 3) broadcast
    // we have one handle, just a diff rawTxn for each case
    const rawTxnBroadcast = [
      BROADCAST_OPTIONS.bySelf,
      BROADCAST_OPTIONS.bySelf7702,
      BROADCAST_OPTIONS.byOtherEOA,
      BROADCAST_OPTIONS.delegation
    ]

    if (rawTxnBroadcast.includes(accountOp.gasFeePayment.broadcastOption)) {
      const multipleTxnsBroadcastRes = []
      const senderAddr =
        accountOp.gasFeePayment.broadcastOption === BROADCAST_OPTIONS.byOtherEOA
          ? accountOp.gasFeePayment.paidBy
          : accountOp.accountAddr
      // A speed-up MUST reuse the nonce of the txn it replaces — that is the whole
      // point of an RBF, and the flow hands it to us on `accountOp.eoaNonce`
      // (SummaryFooter copies it off the submitted op). Every other broadcast reads
      // the nonce from the chain: `eoaNonce` is also written a few lines below, on
      // every attempt, so a retry after a partially broadcast batch (the swap flow
      // rethrows and lets the user press Swap again) used to reuse a nonce the chain
      // had already consumed. Every txn built from it was doomed, and the gas
      // estimation spun on the mismatch for ~16s instead of saying so.
      const cachedEoaNonce =
        accountOp.eoaNonce !== null && typeof accountOp.eoaNonce !== 'undefined'
          ? Number(accountOp.eoaNonce)
          : null
      const senderNonce =
        this.isSpeedUpTransaction && cachedEoaNonce !== null
          ? cachedEoaNonce
          : await this.provider.getTransactionCount(senderAddr).catch((e) => e)

      // @precaution
      if (senderNonce instanceof Error) {
        return this.throwBroadcastAccountOp({
          message: 'RPC error. Please try again',
          accountState
        })
      }

      try {
        const { gasFeePayment } = accountOp

        if (!gasFeePayment.paidBy || !gasFeePayment.paidByKeyType) {
          const message = `Missing gas fee payment details. ${contactSupportPrompt}`
          return this.throwBroadcastAccountOp({ message })
        }

        const signer = await this.#keystore.getSigner(
          gasFeePayment.paidBy,
          gasFeePayment.paidByKeyType
        )
        if (signer.init) {
          signer.init(this.#externalSignerControllers[gasFeePayment.paidByKeyType])
        }

        const txnLength = this.baseAccount.shouldBroadcastCallsSeparately(accountOp)
          ? accountOp.calls.length
          : 1
        this.#updateAccountOp({ eoaNonce: BigInt(senderNonce) })
        if (txnLength > 1) this.update({ signedTransactionsCount: 0 })
        for (let i = 0; i < txnLength; i++) {
          const currentNonce = senderNonce + i
          const isDelegationBroadcast =
            gasFeePayment.broadcastOption === BROADCAST_OPTIONS.delegation
          const rawTxn = await buildRawTransaction(
            account,
            accountOp,
            accountState,
            this.provider,
            this.#network,
            currentNonce,
            gasFeePayment.broadcastOption,
            accountOp.calls[i]
          )
          const signedTxn = await this.#withHardwareWalletSigningRequest(
            getRawTransactionSigningRequest(rawTxn),
            () =>
              isDelegationBroadcast
                ? signer.signTransactionTypeFour({
                    txnRequest: rawTxn,
                    eip7702Auth: accountOp.meta!.delegation!
                  })
                : signer.signRawTransaction(rawTxn)
          )

          if (isDelegationBroadcast) {
            multipleTxnsBroadcastRes.push({
              hash: await this.provider.send('eth_sendRawTransaction', [signedTxn])
            })
          } else if (signedTxn.length === 66) {
            // Already broadcast by external signer (e.g. WalletConnect eth_sendTransaction)
            // signedTxn is a tx hash, not a signed transaction
            multipleTxnsBroadcastRes.push({ hash: signedTxn })
          } else {
            multipleTxnsBroadcastRes.push(
              await broadcastTransaction(this.provider, signedTxn, accountOp.chainId)
            )
          }
          if (txnLength > 1) this.update({ signedTransactionsCount: i + 1 })

          // eslint-disable-next-line no-console
          console.log('[BCDBG] broadcast loop iteration done', {
            i,
            txnLength,
            hash: multipleTxnsBroadcastRes[multipleTxnsBroadcastRes.length - 1]?.hash
          })

          // Record the EOA txn — but only on chains the relayer actually serves.
          // Calling it unconditionally makes every broadcast on a relayer-less
          // chain (e.g. PulseChain) end in `RelayerError: not supported chainId`,
          // which the catch below then hides in the console.
          if (hasRelayerSupport(this.#network)) {
            this.#callRelayer(`/v2/eoaSubmitTxn/${accountOp.chainId}`, 'POST', {
              rawTxn: signedTxn
            }).catch((e: any) => {
              this.emitError({
                level: 'silent',
                message: 'Failed to record the EOA transaction to the relayer.',
                error: e instanceof Error ? e : new Error(String(e))
              })
            })
          }

          // Don't start the next txn of the batch until this one is on chain.
          // Sequential nonces already pin the execution order, but the *estimation*
          // of the next call runs against whatever pending state the RPC happens to
          // have: a swap estimated while the approval it spends is still unseen
          // reverts with ERC20InsufficientAllowance. On top of that, WalletConnect
          // wallets (SafePal) pick their own nonce and reuse it if the previous txn
          // is still pending, and some drop a request that arrives while their
          // approval screen is busy.
          const lastHash = multipleTxnsBroadcastRes[multipleTxnsBroadcastRes.length - 1]?.hash
          // A 66-char `signedTxn` is a hash returned by an external signer that
          // broadcast on our behalf — there is no raw txn of ours to re-send.
          const ownRawTxn = signedTxn.length === 66 ? undefined : signedTxn
          if (lastHash) {
            if (i < txnLength - 1) {
              await this.#waitForInclusion(lastHash, ownRawTxn)
            } else if (ownRawTxn) {
              // The last txn has nothing after it to estimate, so waiting here
              // would only hold the signing screen open. The propagation safety
              // net still applies though — a txn accepted by a single endpoint
              // has been observed never reaching the miners — so run it detached.
              this.#waitForInclusion(lastHash, ownRawTxn).catch(() => {})
            }
          }
        }

        transactionRes = {
          nonce:
            accountOp.gasFeePayment.broadcastOption === BROADCAST_OPTIONS.byOtherEOA
              ? Number(accountOp.nonce)
              : senderNonce,
          identifiedBy: {
            type: txnLength > 1 ? 'MultipleTxns' : 'Transaction',
            identifier: multipleTxnsBroadcastRes.map((res) => res.hash).join('-')
          },
          txnId: multipleTxnsBroadcastRes[multipleTxnsBroadcastRes.length - 1]?.hash
        }
      } catch (error: any) {
        // eslint-disable-next-line no-console
        console.error('Error broadcasting', error)
        // for multiple txn cases
        // if a batch of 5 txn is sent to Ledger for sign but the user reject
        // #3, #1 and #2 are already broadcast. Reduce the accountOp's call
        // to #1 and #2 and create a submittedAccountOp
        //
        // unless it's the build-in swap - we want to throw an error and
        // allow the user to retry in this case
        if (multipleTxnsBroadcastRes.length && this.#type !== 'one-click-swap-and-bridge') {
          transactionRes = {
            nonce: senderNonce,
            identifiedBy: {
              type: 'MultipleTxns',
              identifier: multipleTxnsBroadcastRes.map((res) => res.hash).join('-')
            },
            txnId: multipleTxnsBroadcastRes[multipleTxnsBroadcastRes.length - 1]?.hash
          }
        } else {
          return this.throwBroadcastAccountOp({ error, accountState })
        }
      } finally {
        this.update({ signedTransactionsCount: null })
      }
    }
    // Smart account, the ERC-4337 way
    else if (accountOp.gasFeePayment?.broadcastOption === BROADCAST_OPTIONS.byBundler) {
      const userOperation = accountOp.asUserOperation
      if (!userOperation) {
        const accAddr = shortenAddress(accountOp.accountAddr, 13)
        const message = `Trying to broadcast an ERC-4337 request but userOperation is not set for the account with address ${accAddr}`
        return this.throwBroadcastAccountOp({ message, accountState })
      }

      // broadcast through bundler's service
      let userOperationHash
      const bundler = bundlerSwitcher.getBundler()
      try {
        userOperationHash = await bundler.broadcast(userOperation, this.#network)
      } catch (e: any) {
        let retryMsg

        // if the signAccountOp is still active (it should be)
        // try to switch the bundler and ask the user to try again
        const switcher = this.bundlerSwitcher
        this.updateStatus(SigningStatus.ReadyToSign)

        if (switcher.canSwitch(this.baseAccount)) {
          switcher.switch()
          this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true })
          this.#silentGasPriceUpdate()
          retryMsg = 'Broadcast failed because bundler was down. Please try again'
        }

        return this.throwBroadcastAccountOp({
          error: e,
          accountState,
          provider: this.provider,
          network: this.#network,
          message: retryMsg
        })
      }
      if (!userOperationHash) {
        return this.throwBroadcastAccountOp({
          message: 'Bundler broadcast failed. Please try broadcasting by an EOA or contact support.'
        })
      }

      transactionRes = {
        nonce: Number(userOperation.nonce),
        identifiedBy: {
          type: 'UserOperation',
          identifier: userOperationHash,
          bundler: bundler.getName()
        }
      }
    }
    // Smart account, the Relayer way
    else {
      try {
        const body = {
          gasLimit: Number(await this.#getRelayerBroadcastGasLimit(accountOp)),
          txns: getSignableCalls(accountOp),
          signature: accountOp.signature,
          signer: { address: accountOp.signingKeyAddr },
          nonce: Number(accountOp.nonce)
        }
        const additionalRelayerNetwork = relayerAdditionalNetworks.find(
          (net) => net.chainId === this.#network.chainId
        )
        const relayerChainId = additionalRelayerNetwork
          ? additionalRelayerNetwork.chainId
          : accountOp.chainId
        const response = await this.#callRelayer(
          `/identity/${accountOp.accountAddr}/${relayerChainId}/submit`,
          'POST',
          body
        )
        if (!response.success) throw new Error(response.message)

        transactionRes = {
          txnId: response.txId,
          nonce: Number(accountOp.nonce),
          identifiedBy: {
            type: 'Relayer',
            identifier: response.id
          }
        }
      } catch (error: any) {
        return this.throwBroadcastAccountOp({ error, accountState, isRelayer: true })
      }
    }

    if (!transactionRes)
      return this.throwBroadcastAccountOp({
        message: 'No transaction response received after being broadcasted.'
      })

    const submittedAccountOp: SubmittedAccountOp = {
      ...accountOp,
      eoaNonce: this.accountOp.eoaNonce,
      status: AccountOpStatus.BroadcastedButNotConfirmed,
      txnId: transactionRes.txnId,
      nonce: BigInt(transactionRes.nonce),
      identifiedBy: transactionRes.identifiedBy,
      timestamp: new Date().getTime(),
      isSingletonDeploy: !!accountOp.calls.find(
        (call) => call.to && getAddress(call.to) === SINGLETON
      )
    }

    // eslint-disable-next-line no-console
    console.log('[BCDBG] built submittedAccountOp, calling onBroadcastSuccess', {
      identifiedBy: submittedAccountOp.identifiedBy,
      txnId: submittedAccountOp.txnId
    })
    await this.#onBroadcastSuccess({
      submittedAccountOp,
      accountOp: this.accountOp,
      type: this.#type,
      fromRequestId: this.fromRequestId
    })
    // eslint-disable-next-line no-console
    console.log('[BCDBG] onBroadcastSuccess RESOLVED')

    // Allow the user to broadcast a new transaction;
    // Important: Update broadcastStatus to SUCCESS/INITIAL only after the onBroadcastSuccess completes.
    // Otherwise, new calls could be added to a previously broadcast request that will resolve shortly,
    // leaving the new request 'orphaned' in the background without being attached to any action.
    this.broadcastStatus = 'SUCCESS'
    await this.forceEmitUpdate()
    this.broadcastStatus = 'INITIAL'
    await this.forceEmitUpdate()
    return Promise.resolve()
  }

  async signAndBroadcast() {
    if (this.signAndBroadcastPromise) {
      return this.emitError({
        level: 'major',
        message:
          'Please wait, the signing/broadcasting process of this transaction is already in progress.',
        error: new Error(
          `The signing/broadcasting process is already in progress. (signAndBroadcast func). Status: ${
            this.status
          }. BroadcastStatus: ${this.broadcastStatus}. Signing key: ${
            this.accountOp.signingKeyType
          }. Fee payer key: ${this.accountOp.gasFeePayment?.paidByKeyType}. Type: ${this.#type}.`
        )
      })
    }

    this.signAndBroadcastPromise = (async () => {
      this.signPromise = this.sign().finally(() => {
        this.signPromise = undefined
      })
      await this.signPromise
      if (this.status && this.status.type === SigningStatus.Done) {
        this.broadcastPromise = this.#broadcast().finally(() => {
          this.broadcastPromise = undefined
        })
        await this.broadcastPromise
      }
      if (
        this.status &&
        this.status.type === SigningStatus.Queued &&
        (this.accountOp.signed || []).length >= this.threshold
      ) {
        this.status.type = SigningStatus.ReadyToSign
        this.emitUpdate()
      }
    })().finally(() => {
      this.signAndBroadcastPromise = undefined
    })

    await this.signAndBroadcastPromise
  }

  #hwCleanup() {
    this.hardwareWalletSigningRequest = null

    const paidByKeyType = this.accountOp.gasFeePayment?.paidByKeyType
    const uniqueSigningKeys = [...new Set([this.accountOp.signingKeyType, paidByKeyType])]

    // Call the cleanup method for each unique signing key type
    uniqueSigningKeys.forEach((keyType) => {
      if (!keyType || keyType === 'internal') return

      this.#externalSignerControllers[keyType]?.signingCleanup?.()
    })
  }

  get isSignInProgress() {
    return !!this.signPromise
  }

  get isBroadcastInProgress() {
    return !!this.broadcastPromise
  }

  get isSignAndBroadcastInProgress() {
    return !!this.signAndBroadcastPromise
  }

  throwBroadcastAccountOp({
    message: humanReadableMessage,
    error: _err,
    accountState,
    isRelayer = false,
    provider = undefined,
    network = undefined
  }: {
    message?: string
    error?: Error | EmittableError | ExternalSignerError
    accountState?: AccountOnchainState
    isRelayer?: boolean
    provider?: RPCProvider
    network?: Network
  }) {
    const originalMessage = _err?.message
    let message = humanReadableMessage
    let isReplacementFeeLow = false

    this.broadcastStatus = 'ERROR'
    this.forceEmitUpdate()
    this.broadcastStatus = 'INITIAL'
    this.forceEmitUpdate()

    if (originalMessage) {
      if (originalMessage.includes('replacement fee too low')) {
        // if custom gas prices have been set, show the original error
        if (!this.hasCustomGasPrices) {
          message =
            'Replacement fee is insufficient. Fees have been automatically adjusted so please try submitting your transaction again.'
          isReplacementFeeLow = true
          this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true })
        }
      } else if (originalMessage.includes('INSUFFICIENT_PRIVILEGE')) {
        message = accountState?.isV2
          ? 'Broadcast failed because of a pending transaction. Please try again'
          : 'Signer key not supported on this network'
        this.#accounts
          .updateAccountState(this.accountOp.accountAddr, 'pending', [this.accountOp.chainId])
          .then(() => this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true }))
          .catch((e) => e)
      } else if (isFeeBelowBroadcastCost(originalMessage)) {
        // ZKX: structural shortfall, NOT gas-price drift — do not refresh the
        // gas price and do not invite a retry that is guaranteed to fail.
        message = this.#getPaymasterRejectionMessage(originalMessage)
      } else if (isUnderpriced(originalMessage)) {
        if (
          originalMessage.includes('underpriced') ||
          originalMessage.includes('maxFeePerGas') ||
          originalMessage.includes('maxPriorityFeePerGas')
        ) {
          if (!this.hasCustomGasPrices) message = 'Transaction fees changed. Please try again'
          else message = originalMessage
        }

        if (!this.hasCustomGasPrices) {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          this.#silentGasPriceUpdate()
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true })
        }
      } else if (originalMessage.includes('Failed to fetch') && isRelayer) {
        message =
          'Currently, the relayer seems to be down. Please try again a few moments later or broadcast with an EOA account'
      } else if (
        originalMessage.includes('INVALID_ACCOUNT_NONCE') ||
        originalMessage.includes('user nonce')
      ) {
        message = 'Pending transaction detected. Please try again in a few seconds'
        this.#accounts
          .updateAccountState(this.accountOp.accountAddr, 'pending', [this.accountOp.chainId])
          .then(() => this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true }))
          .catch((e) => e)
      }
    }

    if (!message) {
      message = getHumanReadableBroadcastError(_err || new Error('')).message

      // if the message states that the paymaster doesn't have sufficient amount,
      // add it to the failedPaymasters to disable it until a top-up is made
      if (message.includes(insufficientPaymasterFunds) && provider && network) {
        failedPaymasters.addInsufficientFunds(provider, network).then(() => {
          this.#simulateAndEstimateOrSimulateInterval.restart({ runImmediately: true })
        })
      }
      if (message.includes('the selected fee is too low')) {
        this.#silentGasPriceUpdate()
      }
    }

    // To enable another try for signing in case of broadcast fail
    // broadcast is called in the FE only after successful signing
    this.updateStatus(SigningStatus.ReadyToSign, isReplacementFeeLow)

    if (this.#onBroadcastFailed) {
      this.#onBroadcastFailed(this.#accountOp)
    }

    this.emitError({
      level: 'major',
      message,
      error: _err || new Error(message),
      sendCrashReport: _err && 'sendCrashReport' in _err ? _err.sendCrashReport : undefined
    })
    throw new Error(message) // so that broadcast resolves with an error status
  }

  canUpdate(): boolean {
    return !this.status || noStateUpdateStatuses.indexOf(this.status.type) === -1
  }

  setDiscoveryStatus(status: TraceCallDiscoveryStatus) {
    this.traceCallDiscoveryStatus = status
  }

  /**
   * Unbrick mechanism.
   * Use this only when you are sure there's no way to continue, or
   * a promise waiting to resolve that might change the state
   */
  cancelSignReq() {
    this.signPromise = undefined
    this.broadcastPromise = undefined
    this.signAndBroadcastPromise = undefined
    this.status = { type: SigningStatus.ReadyToSign }
    this.emitUpdate()
  }

  get type() {
    return this.#type
  }

  get delegatedContract(): Hex | null {
    if (!this.#accounts.accountStates[this.account.addr]) return null
    if (!this.#accounts.accountStates[this.account.addr]![this.#network.chainId.toString()])
      return null
    return this.#accounts.accountStates[this.account.addr]![this.#network.chainId.toString()]!
      .delegatedContract
  }

  get banners(): SignAccountOpBanner[] {
    const banners: SignAccountOpBanner[] = []

    const visualizations = this.humanization.flatMap((call) => call.fullVisualization ?? [])

    // Keep only token/address types AND ensure uniqueness by address
    const addressVisualizations = Array.from(
      new Map(
        visualizations
          .filter((v) => (v.type === 'token' || v.type === 'address') && v.address)
          .map((v) => [v.address, v]) // key: address → value: visualization
      ).values()
    )

    const blacklistedItems = addressVisualizations.filter((v) => v.verification === 'BLACKLISTED')

    if (blacklistedItems.length) {
      banners.push({
        id: 'blacklisted-addresses-error-banner',
        type: 'error',
        text: getScamDetectedText(blacklistedItems)
      })
    } else {
      const hasFailedToGet = visualizations.some(
        (v) => (v.type === 'token' || v.type === 'address') && v.verification === 'FAILED_TO_GET'
      )

      if (hasFailedToGet) {
        banners.push({
          id: 'blacklisted-addresses-warning-banner',
          type: 'warning',
          text: "We couldn't check the addresses or tokens in this transaction for malicious activity. Proceed with caution."
        })
      }
    }

    const dappVerificationBanner = this.#getDappVerificationBanner()
    if (dappVerificationBanner) banners.push(dappVerificationBanner)

    return banners
  }

  get canAccountBroadcastByItself(): boolean {
    return this.baseAccount.canBroadcastByItself()
  }

  get canSetCustomGasPrices(): boolean {
    if (!this.selectedOption) return false

    return this.baseAccount.canSetCustomGasPrices(this.selectedOption)
  }

  get canSetCustomGas(): boolean {
    if (!this.selectedOption) return false

    return this.baseAccount.canSetCustomGas(this.selectedOption, this.accountOp)
  }

  get threshold(): number {
    const accountState =
      this.#accounts.accountStates[this.account.addr]![this.#network.chainId.toString()]
    if (!accountState) return 0
    return accountState.threshold
  }

  get canBroadcast() {
    if (!this.account.safeCreation) return true

    // if the threshold is 1 and there's only 1 imported key, allow quick broadcast
    if (this.threshold === 1 && this.accountKeyStoreKeys.length === 1) return true

    return (this.accountOp.signed || []).length >= this.threshold
  }

  toJSON() {
    return {
      ...this,
      ...super.toJSON(),
      isInitialized: this.isInitialized,
      type: this.type,
      readyToSign: this.readyToSign,
      safetyChecksLoading: this.safetyChecksLoading,
      accountKeyStoreKeys: this.accountKeyStoreKeys,
      feePayerKeyStoreKeys: this.feePayerKeyStoreKeys,
      feeToken: this.feeToken,
      speedOptions: this.speedOptions,
      selectedOption: this.selectedOption,
      account: this.account,
      errors: this.errors,
      gasSavedUSD: this.gasSavedUSD,
      delegatedContract: this.delegatedContract,
      accountOp: this.accountOp,
      isSignInProgress: this.isSignInProgress,
      isBroadcastInProgress: this.isBroadcastInProgress,
      isSignAndBroadcastInProgress: this.isSignAndBroadcastInProgress,
      banners: this.banners,
      canAccountBroadcastByItself: this.canAccountBroadcastByItself,
      canSetCustomGasPrices: this.canSetCustomGasPrices,
      canSetCustomGas: this.canSetCustomGas,
      threshold: this.threshold,
      canBroadcast: this.canBroadcast,
      hasSafeApiFailed: this.hasSafeApiFailed,
      hardwareWalletSigningRequest: this.hardwareWalletSigningRequest
    }
  }
}
